const ParseX12Data = (data) => {
  //console.log("data>>>>>>>>>>>>>>>>>",data)
  let emptyElements = {};
  let parsedX12 = {};
  let rawX12 = typeof data === 'string' ? data.trim() : '';
  let noErrors = true;
  let repetitionSeparator = null;

  if (!rawX12) {
    return parsedX12;
  }

  const acknowledgmentRequestedCodes = {
    '0' : 'No Interchange Acknowledgment Requested',
    '1' : 'Interchange Acknowledgment Requested (TA1)',
  };
  const authorizationInformationQualifiers = {
    '00' : 'No Authorization Information Present (No Meaningful Information in I02)',
    '03' : 'Additional Data Identification',
  };
  const codeCategories = {
    '44' : 'Nature of Injury',
  };
  const codeListQualifierCodes = {
    'ABF' : 'International Classification of Diseases Clinical Modification (ICD-10-CM) Diagnosis',
    'ABK' : 'International Classification of Diseases Clinical Modification (ICD-10-CM) Principal Diagnosis',
    'BF' : 'International Classification of Diseases Clinical Modification (ICD-9-CM) Diagnosis',
    'BK' : 'International Classification of Diseases Clinical Modification (ICD-9-CM) Principal Diagnosis',
    'GR' : 'National Council on Compensation Insurance (NCCI) Nature of Injury',
    'NI' : 'Nature of Injury',
    'ZZ' : 'Mutually Defined',
  };
  const communicationNumberQualifier = {
    'ED' : 'Electronic Data Interchange Access Number',
    'EM' : 'Electronic Mail',
    'EX' : 'Telephone Extension',
    'FX' : 'Facsimile',
    'TE' : 'Telephone',
    'UR' : 'Uniform Resource Locator (URL)',
    'WP' : 'Work Phone Number',
  };
  const contactFunctionCodes = {
    'IC' : 'Information Contact',
  };
  const coverageLevelCodes = {
    'CHD' : 'Children Only',
    'DEP' : 'Dependents Only',
    'ECH' : 'Employee and Children',
    'EMP' : 'Employee Only',
    'ESP' : 'Employee and Spouse',
    'FAM' : 'Family',
    'IND' : 'Individual',
    'SPC' : 'Spouse and Children',
    'SPO' : 'Spouse Only',
  };
  const dateTimePeriodFormatQualifiers = {
    'D8' : 'Date Expressed in Format CCYYMMDD',
    'RD8' : 'Range of Dates Expressed in Format CCYYMMDD-CCYYMMDD',
  };
  const dateTimeQualifiers = {
    '096' : 'Discharge',
    '102' : 'Issue',
    '152' : 'Effective Date of Change',
    '193' : 'Period Start',
    '194' : 'Period End',
    '198' : 'Completion',
    '290' : 'Coordination of Benefits',
    '291' : 'Plan',
    '292' : 'Benefit',
    '295' : 'Primary Care Provider',
    '304' : 'Latest Visit or Consultation',
    '307' : 'Eligibility',
    '318' : 'Added',
    '340' : 'Consolidated Omnibus Budget Reconciliation Act (COBRA) Begin',
    '341' : 'Consolidated Omnibus Budget Reconciliation Act (COBRA) End',
    '342' : 'Premium Paid to Date Begin',
    '343' : 'Premium Paid to Date End',
    '346' : 'Plan Begin',
    '347' : 'Plan End',
    '348' : 'Benefit Begin',
    '349' : 'Benefit End',
    '356' : 'Eligibility Begin',
    '357' : 'Eligibility End',
    '382' : 'Enrollment',
    '435' : 'Admission',
    '442' : 'Date of Death',
    '458' : 'Certification',
    '472' : 'Service',
    '539' : 'Policy Effective',
    '540' : 'Policy Expiration',
    '636' : 'Date of Last Update',
    '771' : 'Status',
  };
  const eligibilityOrBenefitInformationCodes = {
    '1' : 'Active Coverage',
    '2' : 'Active - Full Risk Capitation',
    '3' : 'Active - Services Capitated',
    '4' : 'Active - Services Capitated to Primary Care Physician',
    '5' : 'Active - Pending Investigation',
    '6' : 'Inactive',
    '7' : 'Inactive - Pending Eligibility Update',
    '8' : 'Inactive - Pending Investigation',
    'A' : 'Co-Insurance',
    'B' : 'Co-Payment',
    'C' : 'Deductible',
    'CB' : 'Coverage Basis',
    'D' : 'Benefit Description',
    'E' : 'Exclusions',
    'F' : 'Limitations',
    'G' : 'Out of Pocket (Stop Loss)',
    'H' : 'Unlimited',
    'I' : 'Non-Covered',
    'J' : 'Cost Containment',
    'K' : 'Reserve',
    'L' : 'Primary Care Provider',
    'M' : 'Pre-existing Condition',
    'MC' : 'Managed Care Coordinator',
    'N' : 'Services Restricted to Following Provider',
    'O' : 'Not Deemed a Medical Necessity',
    'P' : 'Benefit Disclaimer',
    'Q' : 'Second Surgical Opinion Required',
    'R' : 'Other or Additional Payor',
    'S' : 'Prior Year(s) History',
    'T' : 'Card(s) Reported Lost/Stolen',
    'U' : 'Contact Following Entity for Eligibility or Benefit Information',
    'V' : 'Cannot Process',
    'W' : 'Other Source of Data',
    'X' : 'Health Care Facility',
    'Y' : 'Spend Down',
  };
  const employmentStatusCodes = {
    'AE' : 'Active Reserve',
    'AO' : 'Active Military - Overseas',
    'AS' : 'Academy Student',
    'AT' : 'Presidential Appointee',
    'AU' : 'Active Military - USA',
    'CC' : 'Contractor',
    'DD' : 'Dishonorably Discharged',
    'HD' : 'Honorably Discharged',
    'IR' : 'Inactive Reserves',
    'LX' : 'Leave of Absence: Military',
    'PE' : 'Plan to Enlist',
    'RE' : 'Recommissioned',
    'RM' : 'Retired Military - Overseas',
    'RR' : 'Retired Without Recall',
    'RU' : 'Retired Military - USA',
  };
  const entityIdentifierCodes = {
    '03' : 'Dependent',
    '13' : 'Contracted Service Provider',
    '1I' : 'Preferred Provider Organization (PPO)',
    '1P' : 'Provider',
    '2B' : 'Third-Party Administrator',
    '36' : 'Employer',
    '73' : 'Other Physician',
    '80' : 'Hospital',
    'FA' : 'Facility',
    'GP' : 'Gateway Provider',
    'GW' : 'Group',
    'I3' : 'Independent Physicians Association (IPA)',
    'IL' : 'Insured or Subscriber',
    'LR' : 'Legal Representative',
    'OC' : 'Origin Carrier',
    'P3' : 'Primary Care Provider',
    'P4' : 'Prior Insurance Center',
    'P5' : 'Plan Sponsor',
    'PR' : 'Payer',
    'PRP' : 'Primary Payer',
    'SEP' : 'Secondary Payer',
    'TTP' : 'Tertiary Payer',
    'VER' : 'Party Performing Verification',
    'VN' : 'Vendor',
    'VY' : 'Organization Completing Configuration Change',
    'X3' : 'Utilization Management Organization',
    'Y2' : 'Managed Care Organization',
  };
  const entityRelationshipCodes = {
    '01' : 'Parent',
    '02' : 'Child',
    '27' : 'Domestic Partner',
    '41' : 'Spouse',
    '48' : 'Employee',
    '65' : 'Other',
    '72' : 'Unknown',
  };
  const entityTypeQualifiers = {
    '1' : 'Person',
    '2' : 'Non-Person Entity',
  };
  const followUpActionCodes = {
    'C' : 'Please Correct and Resubmit',
    'N' : 'Resubmission Not Allowed',
    'P' : 'Please Resubmit Original Transaction',
    'R' : 'Resubmission Allowed',
    'S' : 'Do Not Resubmit; Inquiry Initiated to a Third Party',
    'W' : 'Please Wait 30 Days and Resubmit',
    'X' : 'Please Wait 10 Days and Resubmit',
    'Y' : 'Do Not Resubmit; We Will Hold Your Request and Respond Again Shortly',
  };
  const genderCodes = {
    'F' : 'Female',
    'M' : 'Male',
    'U' : 'Unknown',
  };
  const governmentServiceAffiliationCodes = {
    'A' : 'Air Force',
    'B' : 'Air Force Reserves',
    'C' : 'Army',
    'D' : 'Army Reserves',
    'E' : 'Coast Guard',
    'F' : 'Marine Corps',
    'G' : 'Marine Corps Reserves',
    'H' : 'National Guard',
    'I' : 'Navy',
    'J' : 'Navy Reserves',
    'K' : 'Other',
    'L' : 'Peace Corp',
    'M' : 'Regular Armed Forces',
    'N' : 'Reserves',
    'O' : 'U.S. Public Health Service',
    'Q' : 'Foreign Military',
    'R' : 'American Red Cross',
    'S' : 'Department of Defense',
    'U' : 'United Services Organization',
    'W' : 'Military Sealift Command',
  };
  const hierarchicalChildCodes = {
    '0' : 'No Subordinate HL Segment in This Hierarchical Structure',
    '1' : 'Additional Subordinate HL Data Segment in This Hierarchical Structure',
  };
  const hierarchicalLevelCodes = {
    '20' : 'Information Source',
    '21' : 'Information Receiver',
    '22' : 'Subscriber',
    '23' : 'Dependent',
  };
  const hierarchicalStructureCodes = {
    '0022' : 'Information Source, Information Receiver, Subscriber, Dependent',
  };
  const identificationCodeQualifiers = {
    '24' : 'Employer\'s Identification Number',
    '34' : 'Social Security Number',
    '46' : 'Electronic Transmitter Identification Number (ETIN)',
    'FA' : 'Facility Identification',
    'FI' : 'Federal Taxpayer\'s Identification Number',
    'II' : 'Standard Unique Health Identifier for each Individual in the United States',
    'MI' : 'Member Identification Number',
    'NI' : 'National Association of Insurance Commissioners (NAIC) Identification',
    'PI' : 'Payor Identification',
    'PP' : 'Pharmacy Process Number',
    'SV' : 'Service Provider Number',
    'XV' : 'Centers for Medicare and Medicaid Services PlanID',
    'XX' : 'Centers for Medicare and Medicaid Services National Provider Identifier',
  };
  const individualRelationshipCodes = {
    '01' : 'Spouse',
    '18' : 'Self',
    '19' : 'Child',
    '20' : 'Employee',
    '21' : 'Unknown',
    '39' : 'Organ Donor',
    '40' : 'Cadaver Donor',
    '53' : 'Life Partner',
    'G8' : 'Other Relationship',
  };
  const industryCodes = {
    '01' : 'Pharmacy',
    '03' : 'School',
    '04' : 'Homeless Shelter',
    '05' : 'Indian Health Service Free-standing Facility',
    '06' : 'Indian Health Service Provider-based Facility',
    '07' : 'Tribal 638 Free-standing Facility',
    '08' : 'Tribal 638 Provider-based Facility',
    '11' : 'Office',
    '12' : 'Home',
    '13' : 'Assisted Living Facility',
    '14' : 'Group Home',
    '15' : 'Mobile Unit',
    '20' : 'Urgent Care Facility',
    '21' : 'Inpatient Hospital',
    '22' : 'Outpatient Hospital',
    '23' : 'Emergency Room - Hospital',
    '24' : 'Ambulatory Surgical Center',
    '25' : 'Birthing Center',
    '26' : 'Military Treatment Facility',
    '31' : 'Skilled Nursing Facility',
    '32' : 'Nursing Facility',
    '33' : 'Custodial Care Facility',
    '34' : 'Hospice',
    '41' : 'Ambulance - Land',
    '42' : 'Ambulance - Air or Water',
    '49' : 'Independent Clinic',
    '50' : 'Federally Qualified Health Center',
    '51' : 'Inpatient Psychiatric Facility',
    '52' : 'Psychiatric Facility - Partial Hospitalization',
    '53' : 'Community Mental Health Center',
    '54' : 'Intermediate Care Facility/Mentally Retarded',
    '55' : 'Residential Substance Abuse Treatment Facility',
    '56' : 'Psychiatric Residential Treatment Center',
    '57' : 'Non-residential Substance Abuse Treatment Facility',
    '60' : 'Mass Immunization Center',
    '61' : 'Comprehensive Inpatient Rehabilitation Facility',
    '62' : 'Comprehensive Outpatient Rehabilitation Facility',
    '65' : 'End-Stage Renal Disease Treatment Facility',
    '71' : 'State or Local Public Health Clinic',
    '72' : 'Rural Health Clinic',
    '81' : 'Independent Laboratory',
    '99' : 'Other Place of Service',
  };
  const informationStatusCodes = {
    'A' : 'Partial',
    'C' : 'Current',
    'L' : 'Latest',
    'O' : 'Oldest',
    'P' : 'Prior',
    'S' : 'Second Most Current',
    'T' : 'Third Most Current',
  };
  const insuranceTypeCodes = {
    '12' : 'Medicare Secondary Working Aged Beneficiary or Spouse with Employer Group Health Plan',
    '13' : 'Medicare Secondary End-Stage Renal Disease Beneficiary in the Mandated Coordination Period with an Employer\'s Group Health Plan',
    '14' : 'Medicare Secondary, No-fault Insurance including Auto is Primary',
    '15' : 'Medicare Secondary Worker\'s Compensation',
    '16' : 'Medicare Secondary Public Health Service (PHS) or Other Federal Agency',
    '41' : 'Medicare Secondary Black Lung',
    '42' : 'Medicare Secondary Veteran\'s Administration',
    '43' : 'Medicare Secondary Disabled Beneficiary Under Age 65 with Large Group Health Plan (LGHP)',
    '47' : 'Medicare Secondary, Other Liability Insurance is Primary',
    'AP' : 'Auto Insurance Policy',
    'C1' : 'Commercial',
    'CO' : 'Consolidated Omnibus Budget Reconciliation Act (COBRA)',
    'CP' : 'Medicare Conditionally Primary',
    'D' : 'Disability',
    'DB' : 'Disability Benefits',
    'EP' : 'Exclusive Provider Organization',
    'FF' : 'Family or Friends',
    'GP' : 'Group Policy',
    'HM' : 'Health Maintenance Organization (HMO)',
    'HN' : 'Health Maintenance Organization (HMO) - Medicare Risk',
    'HS' : 'Special Low Income Medicare Beneficiary',
    'IN' : 'Indemnity',
    'IP' : 'Individual Policy',
    'LC' : 'Long Term Care',
    'LD' : 'Long Term Policy',
    'LI' : 'Life Insurance',
    'LT' : 'Litigation',
    'MA' : 'Medicare Part A',
    'MB' : 'Medicare Part B',
    'MC' : 'Medicaid',
    'MH' : 'Medigap Part A',
    'MI' : 'Medigap Part B',
    'MP' : 'Medicare Primary',
    'OT' : 'Other',
    'PE' : 'Property Insurance - Personal',
    'PL' : 'Personal',
    'PP' : 'Personal Payment (Cash - No Insurance)',
    'PR' : 'Preferred Provider Organization (PPO)',
    'PS' : 'Point of Service',
    'QM' : 'Qualified Medicare Beneficiary',
    'RP' : 'Property Insurance - Real',
    'SP' : 'Supplemental Policy',
    'TF' : 'Tax Equity Fiscal Responsibility Act (TEFRA)',
    'WC' : 'Workers Compensation',
    'WU' : 'Wrap Up Policy',
  };
  const interchangeControlVersionNumbers = {
    '00501' : 'Standards Approved for Publication by ASC X12 Procedures Review Board through 2003',
  };
  const interchangeIdQualifiers = {
    '01' : 'Duns (Dun & Bradstreet)',
    '14' : 'Duns Plus Suffix',
    '20' : 'Health Industry Number (HIN)',
    '27' : 'Carrier Identification Number as assigned by Health Care Financing Administration (HCFA)',
    '28' : 'Fiscal Intermediary Identification Number as assigned by Health Care Financing Administration (HCFA)',
    '29' : 'Medicare Provider and Supplier Identification Number as assigned by Health Care Financing Administration (HCFA)',
    '30' : 'U.S. Federal Tax Identification Number',
    '33' : 'National Association of Insurance Commissioners Company Code (NAIC)',
    'ZZ' : 'Mutually Defined',
  };
  const locationQualifiers = {
    'RJ' : 'Region',
  };
  const maintenanceReasonCodes = {
    '25' : 'Change in Identifying Data Elements',
  };
  const maintenanceTypeCodes = {
    '001' : 'Change',
  };
  const militaryServiceRankCodes = {
    'A1' : 'Admiral',
    'A2' : 'Airman',
    'A3' : 'Airman First Class',
    'B1' : 'Basic Airman',
    'B2' : 'Brigadier General',
    'C1' : 'Captain',
    'C2' : 'Chief Master Sergeant',
    'C3' : 'Chief Petty Officer',
    'C4' : 'Chief Warrant',
    'C5' : 'Colonel',
    'C6' : 'Commander',
    'C7' : 'Commmodore',
    'C8' : 'Corporal',
    'C9' : 'Corporal Specialist 4',
    'E1' : 'Ensign',
    'F1' : 'First Lieutenant',
    'F2' : 'First Sergeant',
    'F3' : 'First Sergeant-Master Sergeant',
    'F4' : 'Fleet Admiral',
    'G1' : 'General',
    'G4' : 'Gunnery Sergeant',
    'L1' : 'Lance Corporal',
    'L2' : 'Lieutenant',
    'L3' : 'Lieutenant Colonel',
    'L4' : 'Lieutenant Commander',
    'L5' : 'Lieutenant General',
    'L6' : 'Lieutenant Junior Grade',
    'M1' : 'Major',
    'M2' : 'Major General',
    'M3' : 'Master Chief Petty Officer',
    'M4' : 'Master Gunnery Sergeant Major',
    'M5' : 'Master Sergeant',
    'M6' : 'Master Sergeant Specialist 8',
    'P1' : 'Petty Officer First Class',
    'P2' : 'Petty Officer Second Class',
    'P3' : 'Petty Officer Third Class',
    'P4' : 'Private',
    'P5' : 'Private First Class',
    'R1' : 'Rear Admiral',
    'R2' : 'Recruit',
    'S1' : 'Seaman',
    'S2' : 'Seaman Apprentice',
    'S3' : 'Seaman Recruit',
    'S4' : 'Second Lieutenant',
    'S5' : 'Senior Chief Petty Officer',
    'S6' : 'Senior Master Sergeant',
    'S7' : 'Sergeant',
    'S8' : 'Sergeant First Class Specialist 7',
    'S9' : 'Sergeant Major Specialist 9',
    'SA' : 'Sergeant Specialist 5',
    'SB' : 'Staff Sergeant',
    'SC' : 'Staff Sergeant Specialist 6',
    'T1' : 'Technical Sergeant',
    'V1' : 'Vice Admiral',
    'W1' : 'Warrant Officer',
  };
  const productServiceIdQualifier = {
    'AD' : 'American Dental Association Codes',
    'CJ' : 'Current Procedural Terminology (CPT) Codes',
    'HC' : 'Health Care Financing Administration Common Procedural Coding System (HCPCS) Codes',
    'ID' : 'International Classification of Diseases, 9th Revision, Clinical Modification (ICD-9-CM) - Procedure',
    'IV' : 'Home Infusion EDI Coalition (HIEC) Product/Service',
    'N4' : 'National Drug Code in 5-4-2 Format',
    'ZZ' : 'Mutually Defined',
  };
  const providerCodes = {
    'AD' : 'Admitting',
    'AT' : 'Attending',
    'BI' : 'Billing',
    'CO' : 'Consulting',
    'CV' : 'Covering',
    'H' : 'Hospital',
    'HH' : 'Home Health Care',
    'LA' : 'Laboratory',
    'OT' : 'Other Physician',
    'P1' : 'Pharmacist',
    'P2' : 'Pharmacy',
    'PC' : 'Primary Care Physician',
    'PE' : 'Performing',
    'R' : 'Rural Health Clinic',
    'RF' : 'Referring',
    'SB' : 'Submitting',
    'SK' : 'Skilled Nursing Facility',
    'SU' : 'Supervising',
  };
  const quantityQualifiers = {
    '8H' : 'Minimum',
    '99' : 'Quantity Used',
    'CA' : 'Covered - Actual',
    'CE' : 'Covered - Estimated',
    'D3' : 'Number of Co-insurance Days',
    'DB' : 'Deductible Blood Units',
    'DY' : 'Days',
    'HS' : 'Hours',
    'FL' : 'Units',
    'LA' : 'Life-time Reserve - Actual',
    'LE' : 'Life-time Reserve - Estimated',
    'M2' : 'Maximum',
    'MN' : 'Month',
    'P6' : 'Number of Services or Procedures',
    'QA' : 'Quantity Approved',
    'S7' : 'Age, High Value',
    'S8' : 'Age, Low Value',
    'VS' : 'Visits',
    'YY' : 'Years',
  };
  const referenceIdentificationQualifiers = {
    '0B' : 'State License Number',
    '18' : 'Plan Number',
    '1C' : 'Medicare Provider Number',
    '1D' : 'Medicaid Provider Number',
    '1J' : 'Facility ID Number',
    '1L' : 'Group or Policy Number',
    '1W' : 'Member Identification Number',
    '3H' : 'Case Number',
    '49' : 'Family Unit Number',
    '4A' : 'Personal Identification Number (PIN)',
    '6P' : 'Group Number',
    '9F' : 'Referral Number',
    'ALS' : 'Alternative List ID',
    'CE' : 'Class of Contract',
    'CLI' : 'Coverage List ID',
    'CT' : 'Contract Number',
    'EA' : 'Medical Record Identification Number',
    'EJ' : 'Patient Account Number',
    'EL' : 'Electronic device pin number',
    'EO' : 'Submitter Identification Number',
    'F6' : 'Health Insurance Claim (HIC) Number',
    'FO' : 'Drug Formulary Number',
    'G1' : 'Prior Authorization Number',
    'GH' : 'Identification Card Serial Number',
    'HJ' : 'Identity Card Number',
    'HPI' : 'Centers for Medicare and Medicaid Services National Provider Identifier',
    'IF' : 'Issue Number',
    'IG' : 'Insurance Policy Number',
    'JD' : 'User Identification',
    'M7' : 'Medical Assistance Category',
    'MRC' : 'Eligibility Category',
    'N5' : 'Provider Plan Network Identification Number',
    'N6' : 'Plan Network Identification Number',
    'N7' : 'Facility Network Identification Number',
    'NQ' : 'Medicaid Recipient Identification Number',
    'PXC' : 'Health Care Provider Taxonomy',
    'Q4' : 'Prior Identifier Number',
    'SY' : 'Social Security Number',
    'TJ' : 'Federal Taxpayer\'s Identification Number',
    'Y4' : 'Agency Claim Number',
  };
  const rejectReasonCodes = {
    '04' : 'Authorized Quantity Exceeded',
    '15' : 'Required application data missing',
    '33' : 'Input Errors',
    '35' : 'Out of Network',
    '41' : 'Authorization/Access Restrictions',
    '42' : 'Unable to Respond at Current Time',
    '43' : 'Invalid/Missing Provider Identification',
    '44' : 'Invalid/Missing Provider Name',
    '45' : 'Invalid/Missing Provider Specialty',
    '47' : 'Invalid/Missing Provider State',
    '48' : 'Invalid/Missing Referring Provider Identification Number',
    '49' : 'Provider is Not Primary Care Physician',
    '50' : 'Provider Ineligible for Inquiries',
    '51' : 'Provider Not on File',
    '52' : 'Service Dates Not Within Provider Plan Enrollment',
    '53' : 'Inquired Benefit Inconsistent with Provider Type',
    '54' : 'Inappropriate Product/Service ID Qualifier',
    '55' : 'Inappropriate Product/Service ID',
    '56' : 'Inappropriate Date',
    '57' : 'Invalid/Missing Date(s) of Service',
    '58' : 'Invalid/Missing Date-of-Birth',
    '60' : 'Date of Birth Follows Date(s) of Service',
    '61' : 'Date of Death Precedes Date(s) of Service',
    '62' : 'Date of Service Not Within Allowable Inquiry Period',
    '63' : 'Date of Service in Future',
    '64' : 'Invalid/Missing Patient ID',
    '65' : 'Invalid/Missing Patient Name',
    '66' : 'Invalid/Missing Patient Gender',
    '67' : 'Patient Not Found',
    '68' : 'Duplicate Patient ID Number',
    '69' : 'Inconsistent with Patient\'s Age',
    '70' : 'Inconsistent with Patient\'s Gender',
    '71' : 'Patient Birth Date Does Not Match That for the Patient on the Database',
    '72' : 'Invalid/Missing Subscriber/Insured ID',
    '73' : 'Invalid/Missing Subscriber/Insured Name',
    '74' : 'Invalid/Missing Subscriber/Insured Gender',
    '75' : 'Subscriber/Insured Not Found',
    '76' : 'Duplicate Subscriber/Insured ID Number',
    '77' : 'Subscriber Found, Patient Not Found',
    '78' : 'Subscriber/Insured Not in Group/Plan Identified',
    '79' : 'Invalid Participant Identification',
    '80' : 'No Response received - Transaction Terminated',
    '97' : 'Invalid or Missing Provider Address',
    '98' : 'Experimental Service or Procedure',
    'AA' : 'Authorization Number Not Found',
    'AE' : 'Requires Primary Care Physician Authorization',
    'AF' : 'Invalid/Missing Diagnosis Code(s)',
    'AG' : 'Invalid/Missing Procedure Code(s)',
    'AO' : 'Additional Patient Condition Information Required',
    'CI' : 'Certification Information Does Not Match Patient',
    'E8' : 'Requires Medical Review',
    'IA' : 'Invalid Authorization Number Format',
    'MA' : 'Missing Authorization Number',
    'T4' : 'Payer Name or Identifier Missing',
  };
  const responsibleAgencyCodes = {
    'X' : 'Accredited Standards Committee X12',
  };
  const securityInformationQualifiers = {
    '00' : 'No Security Information Present (No Meaningful Information in I04)',
    '01' : 'Password',
  };
  const serviceTypeCodes = {
    '1' : 'Medical Care',
    '2' : 'Surgical',
    '3' : 'Consultation',
    '4' : 'Diagnostic X-Ray',
    '5' : 'Diagnostic Lab',
    '6' : 'Radiation Therapy',
    '7' : 'Anesthesia',
    '8' : 'Surgical Assistance',
    '9' : 'Other Medical',
    '10' : 'Blood Charges',
    '11' : 'Used Durable Medical Equipment',
    '12' : 'Durable Medical Equipment Purchase',
    '13' : 'Ambulatory Service Center Facility',
    '14' : 'Renal Supplies in the Home',
    '15' : 'Alternate Method Dialysis',
    '16' : 'Chronic Renal Disease (CRD) Equipment',
    '17' : 'Pre-Admission Testing',
    '18' : 'Durable Medical Equipment Rental',
    '19' : 'Pneumonia Vaccine',
    '20' : 'Second Surgical Opinion',
    '21' : 'Third Surgical Opinion',
    '22' : 'Social Work',
    '23' : 'Diagnostic Dental',
    '24' : 'Periodontics',
    '25' : 'Restorative',
    '26' : 'Endodontics',
    '27' : 'Maxillofacial Prosthetics',
    '28' : 'Adjunctive Dental Services',
    '30' : 'Health Benefit Plan Coverage',
    '32' : 'Plan Waiting Period',
    '33' : 'Chiropractic',
    '34' : 'Chiropractic Office Visits',
    '35' : 'Dental Care',
    '36' : 'Dental Crowns',
    '37' : 'Dental Accident',
    '38' : 'Orthodontics',
    '39' : 'Prosthodontics',
    '40' : 'Oral Surgery',
    '41' : 'Routine (Preventive) Dental',
    '42' : 'Home Health Care',
    '43' : 'Home Health Prescriptions',
    '44' : 'Home Health Visits',
    '45' : 'Hospice',
    '46' : 'Respite Care',
    '47' : 'Hospital',
    '48' : 'Hospital - Inpatient',
    '49' : 'Hospital - Room and Board',
    '50' : 'Hospital - Outpatient',
    '51' : 'Hospital - Emergency Accident',
    '52' : 'Hospital - Emergency Medical',
    '53' : 'Hospital - Ambulatory Surgical',
    '54' : 'Long Term Care',
    '55' : 'Major Medical',
    '56' : 'Medically Related Transportation',
    '57' : 'Air Transportation',
    '58' : 'Cabulance',
    '59' : 'Licensed Ambulance',
    '60' : 'General Benefits',
    '61' : 'In-vitro Fertilization',
    '62' : 'MRI/CAT Scan',
    '63' : 'Donor Procedures',
    '64' : 'Acupuncture',
    '65' : 'Newborn Care',
    '66' : 'Pathology',
    '67' : 'Smoking Cessation',
    '68' : 'Well Baby Care',
    '69' : 'Maternity',
    '70' : 'Transplants',
    '71' : 'Audiology Exam',
    '72' : 'Inhalation Therapy',
    '73' : 'Diagnostic Medical',
    '74' : 'Private Duty Nursing',
    '75' : 'Prosthetic Device',
    '76' : 'Dialysis',
    '77' : 'Otological Exam',
    '78' : 'Chemotherapy',
    '79' : 'Allergy Testing',
    '80' : 'Immunizations',
    '81' : 'Routine Physical',
    '82' : 'Family Planning',
    '83' : 'Infertility',
    '84' : 'Abortion',
    '85' : 'AIDS',
    '86' : 'Emergency Services',
    '87' : 'Cancer',
    '88' : 'Pharmacy',
    '89' : 'Free Standing Prescription Drug',
    '90' : 'Mail Order Prescription Drug',
    '91' : 'Brand Name Prescription Drug',
    '92' : 'Generic Prescription Drug',
    '93' : 'Podiatry',
    '94' : 'Podiatry - Office Visits',
    '95' : 'Podiatry - Nursing Home Visits',
    '96' : 'Professional (Physician)',
    '97' : 'Anesthesiologist',
    '98' : 'Professional (Physician) Visit - Office',
    '99' : 'Professional (Physician) Visit - Inpatient',
    'A0' : 'Professional (Physician) Visit - Outpatient',
    'A1' : 'Professional (Physician) Visit - Nursing Home',
    'A2' : 'Professional (Physician) Visit - Skilled Nursing Facility',
    'A3' : 'Professional (Physician) Visit - Home',
    'A4' : 'Psychiatric',
    'A5' : 'Psychiatric - Room and Board',
    'A6' : 'Psychotherapy',
    'A7' : 'Psychiatric - Inpatient',
    'A8' : 'Psychiatric - Outpatient',
    'A9' : 'Rehabilitation',
    'AA' : 'Rehabilitation - Room and Board',
    'AB' : 'Rehabilitation - Inpatient',
    'AC' : 'Rehabilitation - Outpatient',
    'AD' : 'Occupational Therapy',
    'AE' : 'Physical Medicine',
    'AF' : 'Speech Therapy',
    'AG' : 'Skilled Nursing Care',
    'AH' : 'Skilled Nursing Care - Room and Board',
    'AI' : 'Substance Abuse',
    'AJ' : 'Alcoholism',
    'AK' : 'Drug Addiction',
    'AL' : 'Vision',
    'AM' : 'Frames',
    'AN' : 'Routine Exam',
    'AO' : 'Lenses',
    'AQ' : 'Nonmedically Necessary Physical',
    'AR' : 'Experimental Drug Therapy',
    'B1' : 'Burn Care',
    'B2' : 'Brand Name Prescription Drug - Formulary',
    'B3' : 'Brand Name Prescription Drug - Non-Formulary',
    'BA' : 'Independent Medical Evaluation',
    'BB' : 'Partial Hospitalization (Psychiatric)',
    'BC' : 'Day Care (Psychiatric)',
    'BD' : 'Cognitive Therapy',
    'BE' : 'Massage Therapy',
    'BF' : 'Pulmonary Rehabilitation',
    'BG' : 'Cardiac Rehabilitation',
    'BH' : 'Pediatric',
    'BI' : 'Nursery',
    'BJ' : 'Skin',
    'BK' : 'Orthopedic',
    'BL' : 'Cardiac',
    'BM' : 'Lymphatic',
    'BN' : 'Gastrointestinal',
    'BP' : 'Endocrine',
    'BQ' : 'Neurology',
    'BR' : 'Eye',
    'BS' : 'Invasive Procedures',
    'BT' : 'Gynecological',
    'BU' : 'Obstetrical',
    'BV' : 'Obstetrical/Gynecological',
    'BW' : 'Mail Order Prescription Drug: Brand Name',
    'BX' : 'Mail Order Prescription Drug: Generic',
    'BY' : 'Physician Visit - Office: Sick',
    'BZ' : 'Physician Visit - Office: Well',
    'C1' : 'Coronary Care',
    'CA' : 'Private Duty Nursing - Inpatient',
    'CB' : 'Private Duty Nursing - Outpatient',
    'CC' : 'Surgical Benefits - Professional (Physician)',
    'CD' : 'Surgical Benefits - Facility',
    'CE' : 'Mental Health Provider - Inpatient',
    'CF' : 'Mental Health Provider - Outpatient',
    'CG' : 'Mental Health Facility - Inpatient',
    'CH' : 'Mental Health Facility - Outpatient',
    'CI' : 'Substance Abuse Facility - Inpatient',
    'CJ' : 'Substance Abuse Facility - Outpatient',
    'CK' : 'Screening X-ray',
    'CL' : 'Screening laboratory',
    'CM' : 'Mammogram, High Risk Patient',
    'CN' : 'Mammogram, Low Risk Patient',
    'CO' : 'Flu Vaccination',
    'CP' : 'Eyewear and Eyewear Accessories',
    'CQ' : 'Case Management',
    'DG' : 'Dermatology',
    'DM' : 'Durable Medical Equipment',
    'DS' : 'Diabetic Supplies',
    'GF' : 'Generic Prescription Drug - Formulary',
    'GN' : 'Generic Prescription Drug - Non-Formulary',
    'GY' : 'Allergy',
    'IC' : 'Intensive Care',
    'MH' : 'Mental Health',
    'NI' : 'Neonatal Intensive Care',
    'ON' : 'Oncology',
    'PT' : 'Physical Therapy',
    'PU' : 'Pulmonary',
    'RN' : 'Renal',
    'RT' : 'Residential Psychiatric Treatment',
    'TC' : 'Transitional Care',
    'TN' : 'Transitional Nursery Care',
    'UC' : 'Urgent Care',
  };
  const shipDeliveryOrCalendarPatternCodes = {
    '1' : '1st Week of the Month',
    '2' : '2nd Week of the Month',
    '3' : '3rd Week of the Month',
    '4' : '4th Week of the Month',
    '5' : '5th Week of the Month',
    '6' : '1st & 3rd Weeks of the Month',
    '7' : '2nd & 4th Weeks of the Month',
    '8' : '1st Working Day of Period',
    '9' : 'Last Working Day of Period',
    'A' : 'Monday through Friday',
    'B' : 'Monday through Saturday',
    'C' : 'Monday through Sunday',
    'D' : 'Monday',
    'E' : 'Tuesday',
    'F' : 'Wednesday',
    'G' : 'Thursday',
    'H' : 'Friday',
    'J' : 'Saturday',
    'K' : 'Sunday',
    'L' : 'Monday through Thursday',
    'M' : 'Immediately',
    'N' : 'As Directed',
    'O' : 'Daily Mon. through Fri.',
    'P' : '1/2 Mon. & 1/2 Thurs.',
    'Q' : '1/2 Tues. & 1/2 Thurs.',
    'R' : '1/2 Wed. & 1/2 Fri.',
    'S' : 'Once Anytime Mon. through Fri.',
    'SG' : 'Tuesday through Friday',
    'SL' : 'Monday, Tuesday and Thursday',
    'SP' : 'Monday, Tuesday and Friday',
    'SX' : 'Wednesday and Thursday',
    'SY' : 'Monday, Wednesday and Thursday',
    'SZ' : 'Tuesday, Thursday and Friday',
    'T' : '1/2 Tue. & 1/2 Fri.',
    'U' : '1/2 Mon. & 1/2 Wed.',
    'V' : '1/3 Mon., 1/3 Wed., 1/3 Fri.',
    'W' : 'Whenever Necessary',
    'X' : '1/2 By Wed., Bal. By Fri.',
    'Y' : 'None (Also Used to Cancel or Override a Previous Pattern)',
  };
  const shipDeliveryPatternTimeCodes = {
    'A' : '1st Shift (Normal Working Hours)',
    'B' : '2nd Shift',
    'C' : '3rd Shift',
    'D' : 'A.M.',
    'E' : 'P.M.',
    'F' : 'As Directed',
    'G' : 'Any Shift',
    'Y' : 'None (Also Used to Cancel or Override a Previous Pattern',
  };
  const timePeriodQualifiers = {
    '6' : 'Hour',
    '7' : 'Day',
    '13' : '24 Hours',
    '21' : 'Years',
    '22' : 'Service Year',
    '23' : 'Calendar Year',
    '24' : 'Year to Date',
    '25' : 'Contract',
    '26' : 'Episode',
    '27' : 'Visit',
    '28' : 'Outlier',
    '29' : 'Remaining',
    '30' : 'Exceeded',
    '31' : 'Not Exceeded',
    '32' : 'Lifetime',
    '33' : 'Lifetime Remaining',
    '34' : 'Month',
    '35' : 'Week',
    '36' : 'Admission',
  };
  const traceTypeCodes = {
    '1' : 'Current Transaction Trace Numbers',
    '2' : 'Referenced Transaction Trace Numbers',
  };
  const transactionSetIdentifierCodes = {
    '271' : 'Eligibility, Coverage or Benefit Information',
  };
  const transactionSetPurposeCodes = {
    '06' : 'Confirmation',
    '11' : 'Response',
  };
  const unitOrBasisForMeasurementCodes = {
    'DA' : 'Days',
    'MO' : 'Months',
    'VS' : 'Visit',
    'WK' : 'Week',
    'YR' : 'Years',
  };
  const usageIndicators = {
    'P' : 'Production Data',
    'T' : 'Test Data',
  };
  const versionReleaseIndustryIdentifierCodes = {
    '005010X279A1' : 'Standards Approved for Publication by ASC X12 Procedures Review Board through October 2003',
  };
  const yesNoConditionOrResponseCodes = {
    'N' : 'No',
    'U' : 'Unknown',
    'W' : 'Not Applicable',
    'Y' : 'Yes',
  };
  
  const structure = [
    {
      id:'ISA', name:'Interchange Control Header', repeats:1, required:true,
      elements:[
        {id:'ISA01', name:'Authorization Information Qualifier', required:true, validate:authorizationInformationQualifiers},
        {id:'ISA02', name:'Authorization Info', required:true, validate:null},
        {id:'ISA03', name:'Security Information Qualifier', required:true, validate:securityInformationQualifiers},
        {id:'ISA04', name:'Security Info', required:true, validate:null},
        {id:'ISA05', name:'Interchange ID Qualifier', required:true, validate:interchangeIdQualifiers},
        {id:'ISA06', name:'Interchange Sender ID', required:true, validate:null},
        {id:'ISA07', name:'Interchange ID Qualifier', required:true, validate:interchangeIdQualifiers},
        {id:'ISA08', name:'Interchange Receiver ID', required:true, validate:null},
        {id:'ISA09', name:'Interchange Date', required:true, validate:null},
        {id:'ISA10', name:'Interchange Time', required:true, validate:null},
        {id:'ISA11', name:'Repetition Separator', required:true, validate:null},
        {id:'ISA12', name:'Interchange Control Version Number', required:true, validate:interchangeControlVersionNumbers},
        {id:'ISA13', name:'Interchange Control Number', required:true, validate:null},
        {id:'ISA14', name:'Acknowledgment Requested', required:true, validate:acknowledgmentRequestedCodes},
        {id:'ISA15', name:'Interchange Usage', required:true, validate:usageIndicators},
        {id:'ISA16', name:'Component Element Separator', required:true, validate:null},
      ],
      segments:[
        {
          id:'GS', name:'Functional Group Header', repeats:1, required:true,
          elements:[
            {id:'GS01', name:'Functional Identifier', required:true, validate:null},
            {id:'GS02', name:'Application Sender', required:true, validate:null},
            {id:'GS03', name:'Application Receiver', required:true, validate:null},
            {id:'GS04', name:'Date', required:true, validate:null},
            {id:'GS05', name:'Time', required:true, validate:null},
            {id:'GS06', name:'Group Control Number', required:true, validate:null},
            {id:'GS07', name:'Responsible Agency', required:true, validate:responsibleAgencyCodes},
            {id:'GS08', name:'Version/Release/Industry', required:true, validate:versionReleaseIndustryIdentifierCodes},
          ],
          segments:[
            {
              id:'ST', name:'Transaction Set Header', repeats:1, required:true,
              elements:[
                {id:'ST01', name:'Transaction Set Identifier', required:true, validate:transactionSetIdentifierCodes},
                {id:'ST02', name:'Transaction Set Control Number', required:true, validate:null},
                {id:'ST03', name:'Implementation Convention Reference', required:true, validate:null},
              ],
              segments:[
                {
                  id:'BHT', name:'Beginning Of Hierarchical Transaction', repeats:1, required:true,
                  elements:[
                    {id:'BHT01', name:'Hierarchical Structure', required:true, validate:hierarchicalStructureCodes},
                    {id:'BHT02', name:'Transaction Set Purpose', required:true, validate:transactionSetPurposeCodes},
                    {id:'BHT03', name:'Submitter Transaction Identifier', required:false, validate:null},
                    {id:'BHT04', name:'Transaction Set Creation Date', required:true, validate:null},
                    {id:'BHT05', name:'Transaction Set Creation Time', required:true, validate:null},
                    {id:'BHT06', name:'Transaction Type', required:null, validate:null},
                  ],
                  segments:[],
                },
                {
                  id:'HL', name:'2000A_ Information Source Level', repeats:-1, required:true,
                  elements:[
                    {id:'HL01', name:'Hierarchical ID Number', required:true, validate:null},
                    {id:'HL02', name:'Hierarchical Parent ID Number', required:null, validate:null},
                    {id:'HL03', name:'Hierarchical Level', required:true, validate:hierarchicalLevelCodes},
                    {id:'HL04', name:'Hierarchical Child', required:true, validate:hierarchicalChildCodes},
                  ],
                  segments:[
                    {
                      id:'AAA', name:'Request Validation', repeats:9, required:false,
                      elements:[
                        {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                        {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                        {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                        {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                      ],
                    },
                    {
                      id:'NM1', name:'2100A_ Information Source Name', repeats:1, required:true,
                      elements:[
                        {id:'NM101', name:'Entity Identifier', required:true, validate:entityIdentifierCodes},
                        {id:'NM102', name:'Entity Type Qualifier', required:true, validate:entityTypeQualifiers},
                        {id:'NM103', name:'Information Source Last Or Organization Name', required:true, validate:null},
                        {id:'NM104', name:'Information Source First Name', required:false, validate:null},
                        {id:'NM105', name:'Information Source Middle Name', required:false, validate:null},
                        {id:'NM106', name:'Name Prefix', required:null, validate:null},
                        {id:'NM107', name:'Information Source Name Suffix', required:false, validate:null},
                        {id:'NM108', name:'Identification Code Qualifier', required:true, validate:identificationCodeQualifiers},
                        {id:'NM109', name:'Information Source Primary Identifier', required:true, validate:null},
                        {id:'NM110', name:'Entity Relationship', required:null, validate:null},
                        {id:'NM111', name:'Entity Identifier', required:null, validate:null},
                        {id:'NM112', name:'Name Last Or Organization Name', required:null, validate:null},
                      ],
                      segments:[
                        {
                          id:'PER', name:'Information Source Contact Info', repeats:3, required:false,
                          elements:[
                            {id:'PER01', name:'Contact Function', required:true, validate:contactFunctionCodes},
                            {id:'PER02', name:'Information Source Contact Name', required:false, validate:null},
                            {id:'PER03', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                            {id:'PER04', name:'Information Source Communication Number', required:false, validate:null},
                            {id:'PER05', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                            {id:'PER06', name:'Information Source Communication Number', required:false, validate:null},
                            {id:'PER07', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                            {id:'PER08', name:'Information Source Communication Number', required:false, validate:null},
                            {id:'PER09', name:'Contact Inquiry Reference', required:null, validate:null},
                          ],
                        },
                        {
                          id:'AAA', name:'Request Validation', repeats:9, required:false,
                          elements:[
                            {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                            {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                            {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                            {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                          ],
                        },
                      ],
                    },
                    {
                      id:'HL', name:'2000B_ Information Receiver Level', repeats:-1, required:false,
                      elements:[
                        {id:'HL01', name:'Hierarchical ID Number', required:true, validate:null},
                        {id:'HL02', name:'Hierarchical Parent ID Number', required:true, validate:null},
                        {id:'HL03', name:'Hierarchical Level', required:true, validate:hierarchicalLevelCodes},
                        {id:'HL04', name:'Hierarchical Child', required:true, validate:hierarchicalChildCodes},
                      ],
                      segments:[
                        {
                          id:'NM1', name:'2100B_ Information Receiver Name', repeats:1, required:true,
                          elements:[
                            {id:'NM101', name:'Entity Identifier', required:true, validate:entityIdentifierCodes},
                            {id:'NM102', name:'Entity Type Qualifier', required:true, validate:entityTypeQualifiers},
                            {id:'NM103', name:'Information Receiver Last Or Organization Name', required:false, validate:null},
                            {id:'NM104', name:'Information Receiver First Name', required:false, validate:null},
                            {id:'NM105', name:'Information Receiver Middle Name', required:false, validate:null},
                            {id:'NM106', name:'Name Prefix', required:null, validate:null},
                            {id:'NM107', name:'Information Receiver Name Suffix', required:false, validate:null},
                            {id:'NM108', name:'Identification Code Qualifier', required:true, validate:identificationCodeQualifiers},
                            {id:'NM109', name:'Information Receiver Identification Number', required:true, validate:null},
                            {id:'NM110', name:'Entity Relationship', required:null, validate:null},
                            {id:'NM111', name:'Entity Identifier', required:null, validate:null},
                            {id:'NM112', name:'Name Last Or Organization Name', required:null, validate:null},
                          ],
                          segments:[
                            {
                              id:'REF', name:'Information Receiver Additional Identification', repeats:9, required:false,
                              elements:[
                                {id:'REF01', name:'Reference Identification Qualifier', required:true, validate:referenceIdentificationQualifiers},
                                {id:'REF02', name:'Information Receiver Additional Identifier', required:false, validate:null},
                                {id:'REF03', name:'Information Receiver Additional Identifier State', required:false, validate:null},
                                {id:'REF04', name:'Reference Identifier', required:null, validate:null},
                              ],
                            },
                            {
                              id:'N3', name:'Information Receiver Address', repeats:1, required:false,
                              elements:[
                                {id:'N301', name:'Information Receiver Address Line', required:true, validate:null},
                                {id:'N302', name:'Information Receiver Additional Address Line', required:false, validate:null},
                              ],
                            },
                            {
                              id:'N4', name:'Information Receiver City, State, Zip', repeats:1, required:false,
                              elements:[
                                {id:'N401', name:'Information Receiver City Name', required:true, validate:null},
                                {id:'N402', name:'Information Receiver State', required:false, validate:null},
                                {id:'N403', name:'Information Receiver Postal Zone Or ZIP', required:false, validate:null},
                                {id:'N404', name:'Country', required:false, validate:null},
                                {id:'N405', name:'Location Qualifier', required:false, validate:locationQualifiers},
                                {id:'N406', name:'Location Identifier', required:false, validate:null},
                                {id:'N407', name:'Country Subdivision', required:false, validate:null},
                              ],
                            },
                            {
                              id:'AAA', name:'Information Receiver Request Validation', repeats:9, required:false,
                              elements:[
                                {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                                {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                                {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                                {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                              ],
                            },
                            {
                              id:'PRV', name:'Information Receiver Provider Info', repeats:1, required:false,
                              elements:[
                                {id:'PRV01', name:'Provider', required:true, validate:providerCodes},
                                {id:'PRV02', name:'Reference Identification Qualifier', required:false, validate:referenceIdentificationQualifiers},
                                {id:'PRV03', name:'Information Receiver Provider Taxonomy', required:false, validate:null},
                                {id:'PRV04', name:'State Or Province', required:null, validate:null},
                                {id:'PRV05', name:'Provider Specialty Info', required:null, validate:null},
                                {id:'PRV06', name:'Provider Organization', required:null, validate:null},
                              ],
                            },
                          ],
                        },
                        {
                          id:'HL', name:'2000C_ Subscriber Level', repeats:-1, required:false,
                          elements:[
                            {id:'HL01', name:'Hierarchical ID Number', required:true, validate:null},
                            {id:'HL02', name:'Hierarchical Parent ID Number', required:true, validate:null},
                            {id:'HL03', name:'Hierarchical Level', required:true, validate:hierarchicalLevelCodes},
                            {id:'HL04', name:'Hierarchical Child', required:true, validate:hierarchicalChildCodes},
                          ],
                          segments:[
                            {
                              id:'TRN', name:'Subscriber Trace Number', repeats:3, required:false,
                              elements:[
                                {id:'TRN01', name:'Trace Type', required:true, validate:traceTypeCodes},
                                {id:'TRN02', name:'Trace Number', required:true, validate:null},
                                {id:'TRN03', name:'Trace Assigning Entity Identifier', required:true, validate:null},
                                {id:'TRN04', name:'Trace Assigning Entity Additional Identifier', required:false, validate:null},
                              ],
                            },
                            {
                              id:'NM1', name:'2100C_ Subscriber Name', repeats:1, required:true,
                              elements:[
                                {id:'NM101', name:'Entity Identifier', required:true, validate:entityIdentifierCodes},
                                {id:'NM102', name:'Entity Type Qualifier', required:true, validate:entityTypeQualifiers},
                                {id:'NM103', name:'Subscriber Last Name', required:false, validate:null},
                                {id:'NM104', name:'Subscriber First Name', required:false, validate:null},
                                {id:'NM105', name:'Subscriber Middle Name Or Initial', required:false, validate:null},
                                {id:'NM106', name:'Name Prefix', required:null, validate:null},
                                {id:'NM107', name:'Subscriber Name Suffix', required:false, validate:null},
                                {id:'NM108', name:'Identification Code Qualifier', required:false, validate:identificationCodeQualifiers},
                                {id:'NM109', name:'Subscriber Primary Identifier', required:false, validate:null},
                                {id:'NM110', name:'Entity Relationship', required:null, validate:null},
                                {id:'NM111', name:'Entity Identifier', required:null, validate:null},
                                {id:'NM112', name:'Name Last Or Organization Name', required:null, validate:null},
                              ],
                              segments:[
                                {
                                  id:'REF', name:'Subscriber Additional Identification', repeats:9, required:false,
                                  elements:[
                                    {id:'REF01', name:'Reference Identification Qualifier', required:true, validate:referenceIdentificationQualifiers},
                                    {id:'REF02', name:'Subscriber Supplemental Identifier', required:false, validate:null},
                                    {id:'REF03', name:'Plan Group Or Plan Network Name', required:false, validate:null},
                                    {id:'REF04', name:'Reference Identifier', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'N3', name:'Subscriber Address', repeats:1, required:false,
                                  elements:[
                                    {id:'N301', name:'Subscriber Address Line', required:true, validate:null},
                                    {id:'N302', name:'Subscriber Address Line', required:false, validate:null},
                                  ],
                                },
                                {
                                  id:'N4', name:'Subscriber City, State, Zip', repeats:1, required:false,
                                  elements:[
                                    {id:'N401', name:'Subscriber City Name', required:true, validate:null},
                                    {id:'N402', name:'Subscriber State', required:false, validate:null},
                                    {id:'N403', name:'Subscriber Postal Zone Or ZIP', required:false, validate:null},
                                    {id:'N404', name:'Subscriber Country', required:false, validate:null},
                                    {id:'N405', name:'Location Qualifier', required:null, validate:locationQualifiers},
                                    {id:'N406', name:'Location Identifier', required:null, validate:null},
                                    {id:'N407', name:'Subscriber Country Subdivision', required:false, validate:null},
                                  ],
                                },
                                {
                                  id:'AAA', name:'Subscriber Request Validation', repeats:9, required:false,
                                  elements:[
                                    {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                                    {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                                    {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                                    {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                                  ],
                                },
                                {
                                  id:'PRV', name:'Provider Info', repeats:1, required:false,
                                  elements:[
                                    {id:'PRV01', name:'Provider', required:true, validate:providerCodes},
                                    {id:'PRV02', name:'Reference Identification Qualifier', required:false, validate:referenceIdentificationQualifiers},
                                    {id:'PRV03', name:'Provider Identifier', required:false, validate:null},
                                    {id:'PRV04', name:'State Or Province', required:null, validate:null},
                                    {id:'PRV05', name:'Provider Specialty Info', required:null, validate:null},
                                    {id:'PRV06', name:'Provider Organization', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'DMG', name:'Subscriber Demographic Info', repeats:1, required:false,
                                  elements:[
                                    {id:'DMG01', name:'Date Time Period Format Qualifier', required:false, validate:dateTimePeriodFormatQualifiers},
                                    {id:'DMG02', name:'Subscriber Birth Date', required:false, validate:null},
                                    {id:'DMG03', name:'Subscriber Gender', required:false, validate:genderCodes},
                                    {id:'DMG04', name:'Marital Status', required:null, validate:null},
                                    {id:'DMG05', name:'Composite Race Or Ethnicity Info', required:null, validate:null},
                                    {id:'DMG06', name:'Citizenship Status', required:null, validate:null},
                                    {id:'DMG07', name:'Country', required:null, validate:null},
                                    {id:'DMG08', name:'Basis Of Verification', required:null, validate:null},
                                    {id:'DMG09', name:'Quantity', required:null, validate:null},
                                    {id:'DMG10', name:'Code List Qualifier', required:null, validate:null},
                                    {id:'DMG11', name:'Industry', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'INS', name:'Subscriber Relationship', repeats:1, required:false,
                                  elements:[
                                    {id:'INS01', name:'Insured', required:true, validate:yesNoConditionOrResponseCodes},
                                    {id:'INS02', name:'Individual Relationship', required:true, validate:individualRelationshipCodes},
                                    {id:'INS03', name:'Maintenance Type', required:false, validate:maintenanceTypeCodes},
                                    {id:'INS04', name:'Maintenance Reason', required:false, validate:maintenanceReasonCodes},
                                    {id:'INS05', name:'Benefit Status', required:null, validate:null},
                                    {id:'INS06', name:'Medicare Status', required:null, validate:null},
                                    {id:'INS07', name:'Consolidated Omnibus Budget Reconciliation Act (COBRA) Qualifying', required:null, validate:null},
                                    {id:'INS08', name:'Employment Status', required:null, validate:null},
                                    {id:'INS09', name:'Student Status', required:null, validate:null},
                                    {id:'INS10', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'INS11', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'INS12', name:'Date Time Period', required:null, validate:null},
                                    {id:'INS13', name:'Confidentiality', required:null, validate:null},
                                    {id:'INS14', name:'City Name', required:null, validate:null},
                                    {id:'INS15', name:'State Or Province', required:null, validate:null},
                                    {id:'INS16', name:'Country', required:null, validate:null},
                                    {id:'INS17', name:'Birth Sequence Number', required:false, validate:null},
                                  ],
                                },
                                {
                                  id:'HI', name:'Subscriber Health Care Diagnosis', repeats:1, required:false,
                                  elements:[
                                    {id:'HI01', name:'C022', required:true, validate:null},
                                    {id:'HI01_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI01_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI01_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI01_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI01_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI01_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI01_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI01_8', name:'Industry', required:null, validate:null},
                                    {id:'HI01_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI02', name:'C022', required:false, validate:null},
                                    {id:'HI02_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI02_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI02_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI02_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI02_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI02_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI02_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI02_8', name:'Industry', required:null, validate:null},
                                    {id:'HI02_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI03', name:'C022', required:false, validate:null},
                                    {id:'HI03_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI03_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI03_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI03_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI03_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI03_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI03_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI03_8', name:'Industry', required:null, validate:null},
                                    {id:'HI03_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI04', name:'C022', required:false, validate:null},
                                    {id:'HI04_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI04_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI04_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI04_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI04_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI04_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI04_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI04_8', name:'Industry', required:null, validate:null},
                                    {id:'HI04_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI05', name:'C022', required:false, validate:null},
                                    {id:'HI05_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI05_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI05_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI05_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI05_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI05_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI05_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI05_8', name:'Industry', required:null, validate:null},
                                    {id:'HI05_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI06', name:'C022', required:false, validate:null},
                                    {id:'HI06_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI06_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI06_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI06_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI06_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI06_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI06_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI06_8', name:'Industry', required:null, validate:null},
                                    {id:'HI06_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI07', name:'C022', required:false, validate:null},
                                    {id:'HI07_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI07_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI07_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI07_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI07_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI07_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI07_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI07_8', name:'Industry', required:null, validate:null},
                                    {id:'HI07_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI08', name:'C022', required:false, validate:null},
                                    {id:'HI08_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                    {id:'HI08_2', name:'Diagnosis', required:true, validate:industryCodes},
                                    {id:'HI08_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                    {id:'HI08_4', name:'Date Time Period', required:null, validate:null},
                                    {id:'HI08_5', name:'Monetary Amount', required:null, validate:null},
                                    {id:'HI08_6', name:'Quantity', required:null, validate:null},
                                    {id:'HI08_7', name:'Version Identifier', required:null, validate:null},
                                    {id:'HI08_8', name:'Industry', required:null, validate:null},
                                    {id:'HI08_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                    {id:'HI09', name:'Health Care Code Info', required:null, validate:null},
                                    {id:'HI10', name:'Health Care Code Info', required:null, validate:null},
                                    {id:'HI11', name:'Health Care Code Info', required:null, validate:null},
                                    {id:'HI12', name:'Health Care Code Info', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'DTP', name:'Subscriber Date', repeats:9, required:false,
                                  elements:[
                                    {id:'DTP01', name:'Date/Time Qualifier', required:true, validate:dateTimeQualifiers},
                                    {id:'DTP02', name:'Date Time Period Format Qualifier', required:true, validate:dateTimePeriodFormatQualifiers},
                                    {id:'DTP03', name:'Date Time Period', required:true, validate:null},
                                  ],
                                },
                                {
                                  id:'MPI', name:'Subscriber Military Personnel Info', repeats:1, required:false,
                                  elements:[
                                    {id:'MPI01', name:'Information Status', required:true, validate:informationStatusCodes},
                                    {id:'MPI02', name:'Employment Status', required:true, validate:employmentStatusCodes},
                                    {id:'MPI03', name:'Government Service Affiliation', required:true, validate:governmentServiceAffiliationCodes},
                                    {id:'MPI04', name:'Description', required:false, validate:null},
                                    {id:'MPI05', name:'Military Service Rank', required:false, validate:militaryServiceRankCodes},
                                    {id:'MPI06', name:'Date Time Period Format Qualifier', required:false, validate:dateTimePeriodFormatQualifiers},
                                    {id:'MPI07', name:'Date Time Period', required:false, validate:null},
                                  ],
                                },
                              ],
                            },
                            {
                              id:'EB', name:'2110C_ Subscriber E&B Info', repeats:-1, required:false,
                              elements:[
                                {id:'EB01', name:'E&B Info', required:true, validate:eligibilityOrBenefitInformationCodes},
                                {id:'EB02', name:'Benefit Coverage Level', required:false, validate:coverageLevelCodes},
                                {id:'EB03', name:'Service Type', required:false, validate:serviceTypeCodes},
                                {id:'EB04', name:'Insurance Type', required:false, validate:insuranceTypeCodes},
                                {id:'EB05', name:'Plan Coverage Description', required:false, validate:null},
                                {id:'EB06', name:'Time Period Qualifier', required:false, validate:timePeriodQualifiers},
                                {id:'EB07', name:'Benefit Amount', required:false, validate:null},
                                {id:'EB08', name:'Benefit Percent', required:false, validate:null},
                                {id:'EB09', name:'Quantity Qualifier', required:false, validate:quantityQualifiers},
                                {id:'EB10', name:'Benefit Quantity', required:false, validate:null},
                                {id:'EB11', name:'Authorization', required:false, validate:yesNoConditionOrResponseCodes},
                                {id:'EB12', name:'In Plan Network', required:false, validate:yesNoConditionOrResponseCodes},
                                {id:'EB13', name:'C0003', required:false, validate:null},
                                {id:'EB13_1', name:'Product Or Service ID Qualifier', required:true, validate:productServiceIdQualifier},
                                {id:'EB13_2', name:'Procedure', required:true, validate:null},
                                {id:'EB13_3', name:'Procedure Modifier', required:false, validate:null},
                                {id:'EB13_4', name:'Procedure Modifier', required:false, validate:null},
                                {id:'EB13_5', name:'Procedure Modifier', required:false, validate:null},
                                {id:'EB13_6', name:'Procedure Modifier', required:false, validate:null},
                                {id:'EB13_7', name:'Description', required:null, validate:null},
                                {id:'EB13_8', name:'Product Or Service ID', required:false, validate:null},
                                {id:'EB14', name:'C004', required:false, validate:null},
                                {id:'EB14_1', name:'Diagnosis Code Pointer', required:true, validate:null},
                                {id:'EB14_2', name:'Diagnosis Code Pointer', required:false, validate:null},
                                {id:'EB14_3', name:'Diagnosis Code Pointer', required:false, validate:null},
                                {id:'EB14_4', name:'Diagnosis Code Pointer', required:false, validate:null},
                              ],
                              segments:[
                                {
                                  id:'HSD', name:'Health Care Services Delivery', repeats:9, required:false,
                                  elements:[
                                    {id:'HSD01', name:'Quantity Qualifier', required:false, validate:quantityQualifiers},
                                    {id:'HSD02', name:'Benefit Quantity', required:false, validate:null},
                                    {id:'HSD03', name:'Unit Or Basis For Measurement', required:false, validate:unitOrBasisForMeasurementCodes},
                                    {id:'HSD04', name:'Sample Selection Modulus', required:false, validate:null},
                                    {id:'HSD05', name:'Time Period Qualifier', required:false, validate:timePeriodQualifiers},
                                    {id:'HSD06', name:'Period Count', required:false, validate:null},
                                    {id:'HSD07', name:'Delivery Frequency', required:false, validate:shipDeliveryOrCalendarPatternCodes},
                                    {id:'HSD08', name:'Delivery Pattern Time', required:false, validate:shipDeliveryPatternTimeCodes},
                                  ],
                                },
                                {
                                  id:'REF', name:'Subscriber Additional Identification', repeats:9, required:false,
                                  elements:[
                                    {id:'REF01', name:'Reference Identification Qualifier', required:true, validate:referenceIdentificationQualifiers},
                                    {id:'REF02', name:'Subscriber E&B Identifier', required:false, validate:null},
                                    {id:'REF03', name:'Plan Group Or Plan Network Name', required:false, validate:null},
                                    {id:'REF04', name:'Reference Identifier', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'DTP', name:'Subscriber Eligibility/Benefit Date', repeats:20, required:false,
                                  elements:[
                                    {id:'DTP01', name:'Date/Time Qualifier', required:true, validate:dateTimeQualifiers},
                                    {id:'DTP02', name:'Date Time Period Format Qualifier', required:true, validate:dateTimePeriodFormatQualifiers},
                                    {id:'DTP03', name:'E&B Date Time Period', required:true, validate:null},
                                  ],
                                },
                                {
                                  id:'AAA', name:'Subscriber Request Validation', repeats:9, required:false,
                                  elements:[
                                    {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                                    {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                                    {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                                    {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                                  ],
                                },
                                {
                                  id:'MSG', name:'Message Text', repeats:10, required:false,
                                  elements:[
                                    {id:'MSG01', name:'Text', required:true, validate:null},
                                    {id:'MSG02', name:'Printer Carriage Control', required:null, validate:null},
                                    {id:'MSG03', name:'Number', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'III', name:'2115C_ Subscriber E&B Additional Info', repeats:10, required:false,
                                  elements:[
                                    {id:'III01', name:'Code List Qualifier', required:false, validate:codeListQualifierCodes},
                                    {id:'III02', name:'Industry', required:false, validate:industryCodes},
                                    {id:'III03', name:'Code Category', required:false, validate:codeCategories},
                                    {id:'III04', name:'Injured Body Part Name', required:false, validate:null},
                                    {id:'III05', name:'Quantity', required:null, validate:null},
                                    {id:'III06', name:'Composite Unit Of Measure', required:null, validate:null},
                                    {id:'III07', name:'Surface/Layer/Position', required:null, validate:null},
                                    {id:'III08', name:'Surface/Layer/Position', required:null, validate:null},
                                    {id:'III09', name:'Surface/Layer/Position', required:null, validate:null},
                                  ],
                                },
                                {
                                  id:'LS', name:'Loop Header', repeats:1, required:false,
                                  elements:[
                                    {id:'LS01', name:'Loop Identifier', required:true, validate:null},
                                  ],
                                  segments:[
                                    {
                                      id:'NM1', name:'2120C_ Subscriber Benefit Related Entity Name', repeats:23, required:true,
                                      elements:[
                                        {id:'NM101', name:'Entity Identifier', required:true, validate:entityIdentifierCodes},
                                        {id:'NM102', name:'Entity Type Qualifier', required:true, validate:entityTypeQualifiers},
                                        {id:'NM103', name:'Benefit Related Entity Last Or Organization Name', required:false, validate:null},
                                        {id:'NM104', name:'Benefit Related Entity First Name', required:false, validate:null},
                                        {id:'NM105', name:'Benefit Related Entity Middle Name', required:false, validate:null},
                                        {id:'NM106', name:'Name Prefix', required:null, validate:null},
                                        {id:'NM107', name:'Benefit Related Entity Name Suffix', required:false, validate:null},
                                        {id:'NM108', name:'Identification Code Qualifier', required:false, validate:identificationCodeQualifiers},
                                        {id:'NM109', name:'Benefit Related Identity Identifier', required:false, validate:null},
                                        {id:'NM110', name:'Benefit Related Entity Relationship', required:false, validate:entityRelationshipCodes},
                                        {id:'NM111', name:'Entity Identifier', required:null, validate:null},
                                        {id:'NM112', name:'Name Last Or Organization Name', required:null, validate:null},
                                      ],
                                      segments:[
                                        {
                                          id:'N3', name:'Subscriber Benefit Related Entity Address', repeats:1, required:false,
                                          elements:[
                                            {id:'N301', name:'Benefit Related Entity Address Line', required:true, validate:null},
                                            {id:'N302', name:'Benefit Related Entity Address Line', required:false, validate:null},
                                          ],
                                        },
                                        {
                                          id:'N4', name:'Subscriber Benefit Related Entity City, State, Zip', repeats:1, required:false,
                                          elements:[
                                            {id:'N401', name:'Benefit Related Entity City Name', required:true, validate:null},
                                            {id:'N402', name:'Benefit Related Entity State', required:false, validate:null},
                                            {id:'N403', name:'Benefit Related Entity Postal Zone Or ZIP', required:false, validate:null},
                                            {id:'N404', name:'Benefit Related Entity Country', required:false, validate:null},
                                            {id:'N405', name:'Benefit Related Entity Location Qualifier', required:false, validate:locationQualifiers},
                                            {id:'N406', name:'Benefit Related Entity DOD Health Service Region', required:false, validate:null},
                                            {id:'N407', name:'Benefit Related Entity Country Subdivision', required:false, validate:null},
                                          ],
                                        },
                                        {
                                          id:'PER', name:'Subscriber Benefit Related Entity Contact Info', repeats:3, required:false,
                                          elements:[
                                            {id:'PER01', name:'Contact Function', required:true, validate:contactFunctionCodes},
                                            {id:'PER02', name:'Benefit Related Entity Contact Name', required:false, validate:null},
                                            {id:'PER03', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                                            {id:'PER04', name:'Benefit Related Entity Communication Number', required:false, validate:null},
                                            {id:'PER05', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                                            {id:'PER06', name:'Benefit Related Entity Communication Number', required:false, validate:null},
                                            {id:'PER07', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                                            {id:'PER08', name:'Benefit Related Entity Communication Number', required:false, validate:null},
                                            {id:'PER09', name:'Contact Inquiry Reference', required:null, validate:null},
                                          ],
                                        },
                                        {
                                          id:'PRV', name:'Subscriber Benefit Related Provider Info', repeats:1, required:false,
                                          elements:[
                                            {id:'PRV01', name:'Provider', required:true, validate:providerCodes},
                                            {id:'PRV02', name:'Reference Identification Qualifier', required:false, validate:referenceIdentificationQualifiers},
                                            {id:'PRV03', name:'Benefit Related Entity Provider Taxonomy', required:false, validate:null},
                                            {id:'PRV04', name:'State Or Province', required:null, validate:null},
                                            {id:'PRV05', name:'Provider Specialty Info', required:null, validate:null},
                                            {id:'PRV06', name:'Provider Organization', required:null, validate:null},
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  id:'LE', name:'Loop Trailer', repeats:1, required:false,
                                  elements:[
                                    {id:'LE01', name:'Loop Identifier', required:true, validate:null},
                                  ],
                                },
                              ],
                            },
                            {
                              id:'HL', name:'2000D_ Dependent Level', repeats:-1, required:false,
                              elements:[
                                {id:'HL01', name:'Hierarchical ID Number', required:true, validate:null},
                                {id:'HL02', name:'Hierarchical Parent ID Number', required:true, validate:null},
                                {id:'HL03', name:'Hierarchical Level', required:true, validate:hierarchicalLevelCodes},
                                {id:'HL04', name:'Hierarchical Child', required:true, validate:hierarchicalChildCodes},
                              ],
                              segments:[
                                {
                                  id:'TRN', name:'Dependent Trace Number', repeats:3, required:false,
                                  elements:[
                                    {id:'TRN01', name:'Trace Type', required:true, validate:traceTypeCodes},
                                    {id:'TRN02', name:'Trace Number', required:true, validate:null},
                                    {id:'TRN03', name:'Trace Assigning Entity Identifier', required:true, validate:null},
                                    {id:'TRN04', name:'Trace Assigning Entity Additional Identifier', required:false, validate:null},
                                  ],
                                },
                                {
                                  id:'NM1', name:'2100D_ Dependent Name', repeats:1, required:true,
                                  elements:[
                                    {id:'NM101', name:'Entity Identifier', required:true, validate:entityIdentifierCodes},
                                    {id:'NM102', name:'Entity Type Qualifier', required:true, validate:entityTypeQualifiers},
                                    {id:'NM103', name:'Dependent Last Name', required:false, validate:null},
                                    {id:'NM104', name:'Dependent First Name', required:false, validate:null},
                                    {id:'NM105', name:'Dependent Middle Name', required:false, validate:null},
                                    {id:'NM106', name:'Name Prefix', required:null, validate:null},
                                    {id:'NM107', name:'Dependent Name Suffix', required:false, validate:null},
                                    {id:'NM108', name:'Identification Code Qualifier', required:null, validate:null},
                                    {id:'NM109', name:'Identification', required:null, validate:null},
                                    {id:'NM110', name:'Entity Relationship', required:null, validate:null},
                                    {id:'NM111', name:'Entity Identifier', required:null, validate:null},
                                    {id:'NM112', name:'Name Last Or Organization Name', required:null, validate:null},
                                  ],
                                  segments:[
                                    {
                                      id:'REF', name:'Dependent Additional Identification', repeats:9, required:false,
                                      elements:[
                                        {id:'REF01', name:'Reference Identification Qualifier', required:true, validate:referenceIdentificationQualifiers},
                                        {id:'REF02', name:'Dependent Supplemental Identifier', required:false, validate:null},
                                        {id:'REF03', name:'Plan Group Or Plan Network Name', required:false, validate:null},
                                        {id:'REF04', name:'Reference Identifier', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'N3', name:'Dependent Address', repeats:1, required:false,
                                      elements:[
                                        {id:'N301', name:'Dependent Address Line', required:true, validate:null},
                                        {id:'N302', name:'Dependent Address Line', required:false, validate:null},
                                      ],
                                    },
                                    {
                                      id:'N4', name:'Dependent City, State, Zip', repeats:1, required:false,
                                      elements:[
                                        {id:'N401', name:'Dependent City Name', required:true, validate:null},
                                        {id:'N402', name:'Dependent State', required:false, validate:null},
                                        {id:'N403', name:'Dependent Postal Zone Or ZIP', required:false, validate:null},
                                        {id:'N404', name:'Dependent Country', required:false, validate:null},
                                        {id:'N405', name:'Location Qualifier', required:null, validate:locationQualifiers},
                                        {id:'N406', name:'Location Identifier', required:null, validate:null},
                                        {id:'N407', name:'Dependent Country Subdivision', required:false, validate:null},
                                      ],
                                    },
                                    {
                                      id:'AAA', name:'Dependent Request Validation', repeats:9, required:false,
                                      elements:[
                                        {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                                        {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                                        {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                                        {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                                      ],
                                    },
                                    {
                                      id:'PRV', name:'Provider Info', repeats:1, required:false,
                                      elements:[
                                        {id:'PRV01', name:'Provider', required:true, validate:providerCodes},
                                        {id:'PRV02', name:'Reference Identification Qualifier', required:false, validate:referenceIdentificationQualifiers},
                                        {id:'PRV03', name:'Provider Identifier', required:false, validate:null},
                                        {id:'PRV04', name:'State Or Province', required:null, validate:null},
                                        {id:'PRV05', name:'Provider Specialty Info', required:null, validate:null},
                                        {id:'PRV06', name:'Provider Organization', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'DMG', name:'Dependent Demographic Info', repeats:1, required:false,
                                      elements:[
                                        {id:'DMG01', name:'Date Time Period Format Qualifier', required:false, validate:dateTimePeriodFormatQualifiers},
                                        {id:'DMG02', name:'Dependent Birth Date', required:false, validate:null},
                                        {id:'DMG03', name:'Dependent Gender', required:false, validate:genderCodes},
                                        {id:'DMG04', name:'Marital Status', required:null, validate:null},
                                        {id:'DMG05', name:'Composite Race Or Ethnicity Info', required:null, validate:null},
                                        {id:'DMG06', name:'Citizenship Status', required:null, validate:null},
                                        {id:'DMG07', name:'Country', required:null, validate:null},
                                        {id:'DMG08', name:'Basis Of Verification', required:null, validate:null},
                                        {id:'DMG09', name:'Quantity', required:null, validate:null},
                                        {id:'DMG10', name:'Code List Qualifier', required:null, validate:null},
                                        {id:'DMG11', name:'Industry', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'INS', name:'Dependent Relationship', repeats:1, required:false,
                                      elements:[
                                        {id:'INS01', name:'Insured', required:true, validate:yesNoConditionOrResponseCodes},
                                        {id:'INS02', name:'Individual Relationship', required:true, validate:individualRelationshipCodes},
                                        {id:'INS03', name:'Maintenance Type', required:false, validate:maintenanceTypeCodes},
                                        {id:'INS04', name:'Maintenance Reason', required:false, validate:maintenanceReasonCodes},
                                        {id:'INS05', name:'Benefit Status', required:null, validate:null},
                                        {id:'INS06', name:'Medicare Status', required:null, validate:null},
                                        {id:'INS07', name:'Consolidated Omnibus Budget Reconciliation Act (COBRA) Qualifying', required:null, validate:null},
                                        {id:'INS08', name:'Employment Status', required:null, validate:null},
                                        {id:'INS09', name:'Student Status', required:null, validate:null},
                                        {id:'INS10', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'INS11', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'INS12', name:'Date Time Period', required:null, validate:null},
                                        {id:'INS13', name:'Confidentiality', required:null, validate:null},
                                        {id:'INS14', name:'City Name', required:null, validate:null},
                                        {id:'INS15', name:'State Or Province', required:null, validate:null},
                                        {id:'INS16', name:'Country', required:null, validate:null},
                                        {id:'INS17', name:'Birth Sequence Number', required:false, validate:null},
                                      ],
                                    },
                                    {
                                      id:'HI', name:'Dependent Health Care Diagnosis', repeats:1, required:false,
                                      elements:[
                                        {id:'HI01', name:'C022', required:true, validate:null},
                                        {id:'HI01_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI01_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI01_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI01_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI01_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI01_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI01_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI01_8', name:'Industry', required:null, validate:null},
                                        {id:'HI01_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI02', name:'C022', required:false, validate:null},
                                        {id:'HI02_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI02_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI02_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI02_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI02_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI02_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI02_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI02_8', name:'Industry', required:null, validate:null},
                                        {id:'HI02_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI03', name:'C022', required:false, validate:null},
                                        {id:'HI03_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI03_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI03_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI03_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI03_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI03_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI03_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI03_8', name:'Industry', required:null, validate:null},
                                        {id:'HI03_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI04', name:'C022', required:false, validate:null},
                                        {id:'HI04_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI04_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI04_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI04_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI04_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI04_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI04_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI04_8', name:'Industry', required:null, validate:null},
                                        {id:'HI04_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI05', name:'C022', required:false, validate:null},
                                        {id:'HI05_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI05_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI05_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI05_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI05_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI05_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI05_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI05_8', name:'Industry', required:null, validate:null},
                                        {id:'HI05_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI06', name:'C022', required:false, validate:null},
                                        {id:'HI06_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI06_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI06_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI06_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI06_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI06_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI06_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI06_8', name:'Industry', required:null, validate:null},
                                        {id:'HI06_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI07', name:'C022', required:false, validate:null},
                                        {id:'HI07_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI07_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI07_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI07_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI07_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI07_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI07_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI07_8', name:'Industry', required:null, validate:null},
                                        {id:'HI07_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI08', name:'C022', required:false, validate:null},
                                        {id:'HI08_1', name:'Diagnosis Type', required:true, validate:codeListQualifierCodes},
                                        {id:'HI08_2', name:'Diagnosis', required:true, validate:industryCodes},
                                        {id:'HI08_3', name:'Date Time Period Format Qualifier', required:null, validate:null},
                                        {id:'HI08_4', name:'Date Time Period', required:null, validate:null},
                                        {id:'HI08_5', name:'Monetary Amount', required:null, validate:null},
                                        {id:'HI08_6', name:'Quantity', required:null, validate:null},
                                        {id:'HI08_7', name:'Version Identifier', required:null, validate:null},
                                        {id:'HI08_8', name:'Industry', required:null, validate:null},
                                        {id:'HI08_9', name:'Yes/No Condition Or Response', required:null, validate:null},
                                        {id:'HI09', name:'Health Care Code Info', required:null, validate:null},
                                        {id:'HI10', name:'Health Care Code Info', required:null, validate:null},
                                        {id:'HI11', name:'Health Care Code Info', required:null, validate:null},
                                        {id:'HI12', name:'Health Care Code Info', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'DTP', name:'Dependent Date', repeats:9, required:false,
                                      elements:[
                                        {id:'DTP01', name:'Date/Time Qualifier', required:true, validate:dateTimeQualifiers},
                                        {id:'DTP02', name:'Date Time Period Format Qualifier', required:true, validate:dateTimePeriodFormatQualifiers},
                                        {id:'DTP03', name:'Date Time Period', required:true, validate:null},
                                      ],
                                    },
                                    {
                                      id:'MPI', name:'Dependent Military Personnel Info', repeats:1, required:false,
                                      elements:[
                                        {id:'MPI01', name:'Information Status', required:true, validate:informationStatusCodes},
                                        {id:'MPI02', name:'Employment Status', required:true, validate:employmentStatusCodes},
                                        {id:'MPI03', name:'Government Service Affiliation', required:true, validate:governmentServiceAffiliationCodes},
                                        {id:'MPI04', name:'Description', required:false, validate:null},
                                        {id:'MPI05', name:'Military Service Rank', required:false, validate:militaryServiceRankCodes},
                                        {id:'MPI06', name:'Date Time Period Format Qualifier', required:false, validate:dateTimePeriodFormatQualifiers},
                                        {id:'MPI07', name:'Date Time Period', required:false, validate:null},
                                      ],
                                    },
                                  ],
                                },
                                {
                                  id:'EB', name:'2110D_ Dependent E&B Info', repeats:-1, required:false,
                                  elements:[
                                    {id:'EB01', name:'E&B Info', required:true, validate:eligibilityOrBenefitInformationCodes},
                                    {id:'EB02', name:'Benefit Coverage Level', required:false, validate:coverageLevelCodes},
                                    {id:'EB03', name:'Service Type', required:false, validate:serviceTypeCodes},
                                    {id:'EB04', name:'Insurance Type', required:false, validate:insuranceTypeCodes},
                                    {id:'EB05', name:'Plan Coverage Description', required:false, validate:null},
                                    {id:'EB06', name:'Time Period Qualifier', required:false, validate:timePeriodQualifiers},
                                    {id:'EB07', name:'Benefit Amount', required:false, validate:null},
                                    {id:'EB08', name:'Benefit Percent', required:false, validate:null},
                                    {id:'EB09', name:'Quantity Qualifier', required:false, validate:quantityQualifiers},
                                    {id:'EB10', name:'Benefit Quantity', required:false, validate:null},
                                    {id:'EB11', name:'Authorization', required:false, validate:yesNoConditionOrResponseCodes},
                                    {id:'EB12', name:'In Plan Network', required:false, validate:yesNoConditionOrResponseCodes},
                                    {id:'EB13', name:'C0003', required:false, validate:null},
                                    {id:'EB13_1', name:'Product Or Service ID Qualifier', required:true, validate:productServiceIdQualifier},
                                    {id:'EB13_2', name:'Procedure', required:true, validate:null},
                                    {id:'EB13_3', name:'Procedure Modifier', required:false, validate:null},
                                    {id:'EB13_4', name:'Procedure Modifier', required:false, validate:null},
                                    {id:'EB13_5', name:'Procedure Modifier', required:false, validate:null},
                                    {id:'EB13_6', name:'Procedure Modifier', required:false, validate:null},
                                    {id:'EB13_7', name:'Description', required:null, validate:null},
                                    {id:'EB13_8', name:'Product Or Service ID', required:false, validate:null},
                                    {id:'EB14', name:'C004', required:false, validate:null},
                                    {id:'EB14_1', name:'Diagnosis Code Pointer', required:true, validate:null},
                                    {id:'EB14_2', name:'Diagnosis Code Pointer', required:false, validate:null},
                                    {id:'EB14_3', name:'Diagnosis Code Pointer', required:false, validate:null},
                                    {id:'EB14_4', name:'Diagnosis Code Pointer', required:false, validate:null},
                                  ],
                                  segments:[
                                    {
                                      id:'HSD', name:'Health Care Services Delivery', repeats:9, required:false,
                                      elements:[
                                        {id:'HSD01', name:'Quantity Qualifier', required:false, validate:quantityQualifiers},
                                        {id:'HSD02', name:'Benefit Quantity', required:false, validate:null},
                                        {id:'HSD03', name:'Unit Or Basis For Measurement', required:false, validate:unitOrBasisForMeasurementCodes},
                                        {id:'HSD04', name:'Sample Selection Modulus', required:false, validate:null},
                                        {id:'HSD05', name:'Time Period Qualifier', required:false, validate:timePeriodQualifiers},
                                        {id:'HSD06', name:'Period Count', required:false, validate:null},
                                        {id:'HSD07', name:'Delivery Frequency', required:false, validate:shipDeliveryOrCalendarPatternCodes},
                                        {id:'HSD08', name:'Delivery Pattern Time', required:false, validate:shipDeliveryPatternTimeCodes},
                                      ],
                                    },
                                    {
                                      id:'REF', name:'Dependent Additional Identification', repeats:9, required:false,
                                      elements:[
                                        {id:'REF01', name:'Reference Identification Qualifier', required:true, validate:referenceIdentificationQualifiers},
                                        {id:'REF02', name:'Dependent E&B Identifier', required:true, validate:null},
                                        {id:'REF03', name:'Plan Group Or Plan Network Name', required:false, validate:null},
                                        {id:'REF04', name:'Reference Identifier', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'DTP', name:'Dependent Eligibility/Benefit Date', repeats:20, required:false,
                                      elements:[
                                        {id:'DTP01', name:'Date/Time Qualifier', required:true, validate:dateTimeQualifiers},
                                        {id:'DTP02', name:'Date Time Period Format Qualifier', required:true, validate:dateTimePeriodFormatQualifiers},
                                        {id:'DTP03', name:'E&B Date Time Period', required:true, validate:null},
                                      ],
                                    },
                                    {
                                      id:'AAA', name:'Dependent Request Validation', repeats:9, required:false,
                                      elements:[
                                        {id:'AAA01', name:'Valid Request', required:true, validate:yesNoConditionOrResponseCodes},
                                        {id:'AAA02', name:'Agency Qualifier', required:null, validate:null},
                                        {id:'AAA03', name:'Reject Reason', required:true, validate:rejectReasonCodes},
                                        {id:'AAA04', name:'Follow-up Action', required:true, validate:followUpActionCodes},
                                      ],
                                    },
                                    {
                                      id:'MSG', name:'Message Text', repeats:10, required:false,
                                      elements:[
                                        {id:'MSG01', name:'Text', required:true, validate:null},
                                        {id:'MSG02', name:'Printer Carriage Control', required:null, validate:null},
                                        {id:'MSG03', name:'Number', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'III', name:'2115D_ Dependent E&B Additional Info', repeats:10, required:false,
                                      elements:[
                                        {id:'III01', name:'Code List Qualifier', required:false, validate:codeListQualifierCodes},
                                        {id:'III02', name:'Industry', required:false, validate:industryCodes},
                                        {id:'III03', name:'Code Category', required:false, validate:codeCategories},
                                        {id:'III04', name:'Injured Body Part Name', required:false, validate:null},
                                        {id:'III05', name:'Quantity', required:null, validate:null},
                                        {id:'III06', name:'Composite Unit Of Measure', required:null, validate:null},
                                        {id:'III07', name:'Surface/Layer/Position', required:null, validate:null},
                                        {id:'III08', name:'Surface/Layer/Position', required:null, validate:null},
                                        {id:'III09', name:'Surface/Layer/Position', required:null, validate:null},
                                      ],
                                    },
                                    {
                                      id:'LS', name:'Loop Header', repeats:1, required:false,
                                      elements:[
                                        {id:'LS01', name:'Loop Identifier', required:true, validate:null},
                                      ],
                                      segments:[
                                        {
                                          id:'NM1', name:'2120D_ Dependent Benefit Related Entity Name', repeats:23, required:true,
                                          elements:[
                                            {id:'NM101', name:'Entity Identifier', required:true, validate:entityIdentifierCodes},
                                            {id:'NM102', name:'Entity Type Qualifier', required:true, validate:entityTypeQualifiers},
                                            {id:'NM103', name:'Benefit Related Entity Last Or Organization Name', required:false, validate:null},
                                            {id:'NM104', name:'Benefit Related Entity First Name', required:false, validate:null},
                                            {id:'NM105', name:'Benefit Related Entity Middle Name', required:false, validate:null},
                                            {id:'NM106', name:'Name Prefix', required:null, validate:null},
                                            {id:'NM107', name:'Benefit Related Entity Name Suffix', required:false, validate:null},
                                            {id:'NM108', name:'Identification Code Qualifier', required:false, validate:null},
                                            {id:'NM109', name:'Benefit Related Entity Identifier', required:false, validate:null},
                                            {id:'NM110', name:'Benefit Related Entity Relationship', required:false, validate:entityRelationshipCodes},
                                            {id:'NM111', name:'Entity Identifier', required:null, validate:null},
                                            {id:'NM112', name:'Name Last Or Organization Name', required:null, validate:null},
                                          ],
                                          segments:[
                                            {
                                              id:'N3', name:'Dependent Benefit Related Entity Address', repeats:1, required:false,
                                              elements:[
                                                {id:'N301', name:'Benefit Related Entity Address Line', required:true, validate:null},
                                                {id:'N302', name:'Benefit Related Entity Address Line', required:false, validate:null},
                                              ],
                                            },
                                            {
                                              id:'N4', name:'Dependent Benefit Related Entity City, State, Zip', repeats:1, required:false,
                                              elements:[
                                                {id:'N401', name:'Benefit Related Entity City Name', required:true, validate:null},
                                                {id:'N402', name:'Benefit Related Entity State', required:false, validate:null},
                                                {id:'N403', name:'Benefit Related Entity Postal Zone Or ZIP', required:false, validate:null},
                                                {id:'N404', name:'Benefit Related Entity Country', required:false, validate:null},
                                                {id:'N405', name:'Benefit Related Entity Location Qualifier', required:false, validate:locationQualifiers},
                                                {id:'N406', name:'Benefit Related Entity DOD Health Service Region', required:false, validate:null},
                                                {id:'N407', name:'Benefit Related Entity Country Subdivision', required:false, validate:null},
                                              ],
                                            },
                                            {
                                              id:'PER', name:'Dependent Benefit Related Entity Contact Info', repeats:3, required:false,
                                              elements:[
                                                {id:'PER01', name:'Contact Function', required:true, validate:contactFunctionCodes},
                                                {id:'PER02', name:'Benefit Related Entity Contact Name', required:false, validate:null},
                                                {id:'PER03', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                                                {id:'PER04', name:'Benefit Related Entity Communication Number', required:false, validate:null},
                                                {id:'PER05', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                                                {id:'PER06', name:'Benefit Related Entity Communication Number', required:false, validate:null},
                                                {id:'PER07', name:'Communication Number Qualifier', required:false, validate:communicationNumberQualifier},
                                                {id:'PER08', name:'Benefit Related Entity Communication Number', required:false, validate:null},
                                                {id:'PER09', name:'Contact Inquiry Reference', required:null, validate:null},
                                              ],
                                            },
                                            {
                                              id:'PRV', name:'Dependent Benefit Related Provider Info', repeats:1, required:false,
                                              elements:[
                                                {id:'PRV01', name:'Provider', required:true, validate:providerCodes},
                                                {id:'PRV02', name:'Reference Identification Qualifier', required:false, validate:referenceIdentificationQualifiers},
                                                {id:'PRV03', name:'Benefit Related Entity Provider Taxonomy', required:false, validate:null},
                                                {id:'PRV04', name:'State Or Province', required:null, validate:null},
                                                {id:'PRV05', name:'Provider Specialty Info', required:null, validate:null},
                                                {id:'PRV06', name:'Provider Organization', required:null, validate:null},
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      id:'LE', name:'Loop Trailer', repeats:1, required:false,
                                      elements:[
                                        {id:'LE01', name:'Loop Identifier', required:true, validate:null},
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
                    ];


                    const x12Segments = rawX12
                      .split('~')
                      .map(segment => segment?.trim())
                      .filter(Boolean);

                    if (!x12Segments?.length) {
                      return parsedX12;
                    }

                    structure?.forEach(standard => {
                        if (!noErrors) { return false; }
                        noErrors = parseSegment(standard, parsedX12, [...x12Segments]);
                      });
                      //if (!noErrors) { return false; }
                     return parsedX12;


                      
  function parseElement(standard, element, parent) {
    if (standard?.required === null) { return true; }
    emptyElements[standard?.id] = !element;
    if (element) {
      let elementName = standard?.id + '_' + standard?.name
      .split(' ').join('')
      .split('/').join('')
      .split(',').join('')
      .split("'").join('')
      .split('-').join('')
      .split('&').join('');
      if (elementName === 'ISA11_RepetitionSeparator') { repetitionSeparator = element; }
      let values = [element];
      let formattedValues = [];
      if (elementName !== 'ISA11_RepetitionSeparator') { values = element.split(repetitionSeparator); }
      if (standard?.validate) {
        values.forEach(value => {
          if (!Object.keys(standard?.validate).some(key => key === value)) {
            console.error(`Invalid ${standard?.id} ${standard?.name} element: ${value}`);
            return false;
          }
          formattedValues?.push(`${value} [${standard?.validate[value]}]`);
        });
      }
      if (formattedValues?.length > 1) {
        parent[elementName] = formattedValues;
      } else if (formattedValues?.length === 1) {
        parent[elementName] = formattedValues[0];
      } else {
        parent[elementName] = element;
      }
    } else if (standard?.required) {
      const keyParts = standard?.id.split('_');
      const baseElementKey = keyParts[0];
      if (keyParts.length === 1 || !emptyElements?.hasOwnProperty(baseElementKey) || !emptyElements[baseElementKey]) {
        console.error(`Missing ${standard?.id} ${standard?.name} element`);
        return false;
      }
      return true;
    }
    return true;
  }
  function parseSegment(standard, parent, x12Array) {
    //console.log("x12Array>>>>>>>>",x12Array)
    let oneHasBeenFound = false;
    if (!standard?.required) { oneHasBeenFound = true; }
    let repeatPrefix = '';
    let repetitionsFound = 0;
    let continueLooping = true;
    while (continueLooping) {
      if (!Array.isArray(x12Array) || !x12Array?.length || typeof x12Array[0] !== 'string' || !x12Array[0]?.trim()) {
        if (standard?.required) {
          console.error(`Missing ${standard?.id} ${standard?.name} segment`);
          return false;
        }
        return true;
      }
      let elements = x12Array[0].split('*');
      if (!oneHasBeenFound && standard?.required && elements[0] !== standard?.id) {
        console.error(`Missing ${standard?.id} ${standard?.name} segment`);
        return false;
      }
      if (elements[0] === standard?.id && standard?.required !== null) {
        oneHasBeenFound = true;
        repetitionsFound++;
        if (standard?.repeats > 1 && repetitionsFound >= standard?.repeats) {
          continueLooping = false;
        } else {
          x12Array.shift();
          if (standard?.repeats !== 1) {
            if (repetitionsFound < 10) {
              repeatPrefix = '_00' + repetitionsFound.toString();
            } else if (repetitionsFound < 100) {
              repeatPrefix = '_0' + repetitionsFound.toString();
            } else {
              repeatPrefix = '_' + repetitionsFound.toString();
            }
          }
          let segmentName = standard?.id + '_' + standard?.name
          .split(' ').join('')
          .split('/').join('')
          .split(',').join('')
          .split("'").join('')
          .split('-').join('')
          .split('&').join('') + repeatPrefix;
          parent[segmentName] = {};
          let noErrors = true;
          standard?.elements.forEach((element, index) => {
            if (!noErrors) { return false; }
            noErrors = parseElement(element, elements[index + 1], parent[segmentName]);
          });
          if (!noErrors) { return false; }
          noErrors = true;
          if (standard?.hasOwnProperty('segments')) {
            standard?.segments?.forEach(segmentStandard => {
              if (!noErrors) { return false; }
              noErrors = parseSegment(segmentStandard, parent[segmentName], x12Array);
            });
          }
          if (!noErrors) { return false; }
        }
      } else { continueLooping = false; }
    }
    return true;
  }
};
export const parseEDI277 = (ediString) => {

  // Example mappings (ensure these are updated with current codes from X12)
  const claimStatusCategoryCodes = {
    'A0': 'Acknowledgement/Forwarded - The claim/encounter has been forwarded to another entity.',
    'A1': 'Acknowledgement/Receipt - The claim/encounter has been received.',
    'A2': 'Acknowledgement/Acceptance into adjudication system - The claim/encounter has been accepted.',
    'A3': 'Acknowledgement/Returned as unprocessable claim - The claim/encounter has been rejected.',
    'A4': 'Acknowledgement/Not Found - The claim/encounter cannot be found.',
    'A5': 'Acknowledgement/Split Claim - The claim/encounter has been split.',
    'A6': 'Acknowledgement/Rejected for Missing Information.',
    'A7': 'Acknowledgement/Rejected for Invalid Information.',
    'A8': 'Acknowledgement/Rejected for relational field in error.',
    'DR01': 'Acknowledgement/Receipt - Claim received.',
    'DR02': 'Acknowledgement/Acceptance into the data reporting system.',
    'DR03': 'Acknowledgement/Returned as unprocessable claim.',
    'DR04': 'Acknowledgement/Not Found - Claim not found.',
    'DR05': 'Acknowledgement/Rejected for Missing Information.',
    'DR06': 'Acknowledgment/Rejected for invalid information.',
    'DR07': 'Acknowledgement/Rejected for relational field in error.',
    'DR08': 'Acknowledgement/Warning - Claim accepted with warning.',
    'P0': 'Pending: Adjudication/Details - Generic pended claim message.',
    'P1': 'Pending/In Process - Claim is in adjudication.',
    'P2': 'Pending/Payer Review - Claim is suspended and pending review.',
    'P3': 'Pending/Provider Requested Information.',
    'P4': 'Pending/Patient Requested Information.',
    'P5': 'Pending/Payer Administrative/System hold.',
    'F0': 'Finalized - Adjudication complete.',
    'F1': 'Finalized/Payment - Claim/line has been paid.',
    'F2': 'Finalized/Denial - Claim/line has been denied.',
    'F3': 'Finalized/Revised - Adjudication information changed.',
    'F3F': 'Finalized/Forwarded - Claim processing completed and forwarded.',
    'F3N': 'Finalized/Not Forwarded - Claim processing completed but not forwarded.',
    'F4': 'Finalized/Adjudication Complete - No payment forthcoming.',
    'R0': 'Requests for additional Information/General Requests.',
    'R1': 'Requests for additional Information/Entity Requests.',
    'R3': 'Requests for additional Information/Claim/Line.',
    'R4': 'Requests for additional Information/Documentation.',
    'R5': 'Request for additional information/more specific detail.',
    'R6': 'Requests for additional information – Regulatory requirements.',
    'R7': 'Requests for additional information – Confirm care is consistent with policy.',
    'R8': 'Requests for additional information – Confirm care coverage exceptions.',
    'R9': 'Requests for additional information – Determination of medical necessity.',
    'R10': 'Requests for additional information – Support a filed grievance or appeal.',
    'R11': 'Requests for additional information – Pre-payment review of claims.',
    'R12': 'Requests for additional information – Justification for procedure code.',
    'R13': 'Requests for additional information – Original documents unreadable.',
    'R14': 'Requests for additional information – Original documents incorrect.',
    'R15': 'Requests for additional information – Workers Compensation coverage determination.',
    'R16': 'Requests for additional information – Eligibility determination.',
    'R17': 'Replacement of a Prior Request.',
    'E0': 'Response not possible - error on submitted request data.',
    'E1': 'Response not possible - System Status.',
    'E2': 'Information Holder is not responding; resubmit later.',
    'E3': 'Correction required - relational fields in error.',
    'E4': 'Trading partner agreement specific requirement not met.',
    'D0': 'Data Search Unsuccessful - Change search criteria.'
  };
  

const claimStatusCodes = {
  '0': "Cannot provide further status electronically.",
  '1': "For more detailed information, see remittance advice.",
  '2': "More detailed information in letter.",
  '3': "Claim has been adjudicated and is awaiting payment cycle.",
  '6': "Balance due from the subscriber.",
  '12': "One or more originally submitted procedure codes have been combined.",
  '15': "One or more originally submitted procedure code have been modified.",
  '16': "Claim/encounter has been forwarded to entity. Usage: This code requires use of an Entity Code.",
  '17': "Claim/encounter has been forwarded by third party entity to entity. Usage: This code requires use of an Entity Code.",
  '18': "Entity received claim/encounter, but returned invalid status. Usage: This code requires use of an Entity Code.",
  '19': "Entity acknowledges receipt of claim/encounter. Usage: This code requires use of an Entity Code.",
  '20': "Accepted for processing.",
  '21': "Missing or invalid information. Usage: At least one other status code is required to identify the missing or invalid information.",
  '23': "Returned to Entity. Usage: This code requires use of an Entity Code.",
  '24': "Entity not approved as an electronic submitter. Usage: This code requires use of an Entity Code.",
  '25': "Entity not approved. Usage: This code requires use of an Entity Code.",
  '26': "Entity not found. Usage: This code requires use of an Entity Code.",
  '27': "Policy canceled.",
  '29': "Subscriber and policy number/contract number mismatched.",
  '30': "Subscriber and subscriber id mismatched.",
  '31': "Subscriber and policyholder name mismatched.",
  '32': "Subscriber and policy number/contract number not found.",
  '33': "Subscriber and subscriber id not found.",
  '34': "Subscriber and policyholder name not found.",
  '35': "Claim/encounter not found.",
  '37': "Predetermination is on file, awaiting completion of services.",
  '38': "Awaiting next periodic adjudication cycle.",
  '39': "Charges for pregnancy deferred until delivery.",
  '40': "Waiting for final approval.",
  '41': "Special handling required at payer site.",
  '42': "Awaiting related charges.",
  '44': "Charges pending provider audit.",
  '45': "Awaiting benefit determination.",
  '46': "Internal review/audit.",
  '47': "Internal review/audit - partial payment made.",
  '49': "Pending provider accreditation review.",
  '50': "Claim waiting for internal provider verification.",
  '51': "Investigating occupational illness/accident.",
  '52': "Investigating existence of other insurance coverage.",
  '53': "Claim being researched for Insured ID/Group Policy Number error.",
  '54': "Duplicate of a previously processed claim/line.",
  '55': "Claim assigned to an approver/analyst.",
  '56': "Awaiting eligibility determination.",
  '57': "Pending COBRA information requested.",
  '59': "Information was requested by a non-electronic method.",
  '60': "Information was requested by an electronic method.",
  '61': "Eligibility for extended benefits.",
  '64': "Re-pricing information.",
  '65': "Claim/line has been paid.",
  '66': "Payment reflects usual and customary charges.",
  '72': "Claim contains split payment.",
  '73': "Payment made to entity, assignment of benefits not on file.",
  '78': "Duplicate of an existing claim/line, awaiting processing.",
  '81': "Contract/plan does not cover pre-existing conditions.",
  '83': "No coverage for newborns.",
  '84': "Service not authorized.",
  '85': "Entity not primary.",
  '86': "Diagnosis and patient gender mismatch.",
  '88': "Entity not eligible for benefits for submitted dates of service.",
  '89': "Entity not eligible for dental benefits for submitted dates of service.",
  '90': "Entity not eligible for medical benefits for submitted dates of service.",
  '91': "Entity not eligible/not approved for dates of service.",
  '92': "Entity does not meet dependent or student qualification.",
  '93': "Entity is not selected primary care provider.",
  '94': "Entity not referred by selected primary care provider.",
  '95': "Requested additional information not received.",
  '96': "No agreement with entity.",
  '97': "Patient eligibility not found with entity.",
  '98': "Charges applied to deductible.",
  '99': "Pre-treatment review.",
  '100': "Pre-certification penalty taken.",
  '101': "Claim was processed as adjustment to previous claim.",
  '102': "Newborn's charges processed on mother's claim.",
  '103': "Claim combined with other claim(s).",
  '104': "Processed according to plan provisions.",
  '105': "Claim/line is capitated.",
  '106': "This amount is not entity's responsibility.",
  '107': "Processed according to contract provisions.",
  '109': "Entity not eligible.",
  '110': "Claim requires pricing information.",
  '111': "At the policyholder's request these claims cannot be submitted electronically.",
  '114': "Claim/service should be processed by entity.",
  '116': "Claim submitted to incorrect payer.",
  '117': "Claim requires signature-on-file indicator.",
  '121': "Service line number greater than maximum allowable for payer.",
  '123': "Additional information requested from entity.",
  '124': "Entity's name, address, phone and id number.",
  '125': "Entity's name.",
  '126': "Entity's address.",
  '127': "Entity's Communication Number.",
  '128': "Entity's tax id.",
  '129': "Entity's Blue Cross provider id.",
  '130': "Entity's Blue Shield provider id.",
  '131': "Entity's Medicare provider id.",
  '132': "Entity's Medicaid provider id.",
  '133': "Entity's UPIN.",
  '134': "Entity's TRICARE provider id.",
  '135': "Entity's commercial provider id.",
  '136': "Entity's health industry id number.",
  '137': "Entity's plan network id.",
  '138': "Entity's site id.",
  '139': "Entity's health maintenance provider id (HMO).",
  '140': "Entity's preferred provider organization id (PPO).",
  '141': "Entity's administrative services organization id (ASO).",
  '142': "Entity's license/certification number.",
  '143': "Entity's state license number.",
  '144': "Entity's specialty license number.",
  '145': "Entity's specialty/taxonomy code.",
  '146': "Entity's anesthesia license number.",
  '147': "Entity's qualification degree/designation (e.g. RN,PhD,MD).",
  '148': "Entity's social security number.",
  '149': "Entity's employer id.",
  '150': "Entity's drug enforcement agency (DEA) number.",
  '152': "Processor Control Number.",
  '153': "Entity's id number.",
  '154': "Relationship of surgeon & assistant surgeon.",
  '155': "Entity's relationship to patient.",
  '156': "Patient relationship to subscriber.",
  '157': "Entity's Gender.",
  '158': "Entity's Date Of Birth!",
  '159': "Entity's date of death.",
  '160': "Entity's marital status.",
  '161': "Entity's employment status.",
  '162': "Entity's health insurance claim number (HICN).",
  '163': "Entity's policy/group number.",
  '164': "Entity's contract/member number.",
  '165': "Entity's employer name, address and phone.",
  '166': "Entity's employer name.",
  '167': "Entity's employer address.",
  '168': "Entity's employer phone number.",
  '170': "Entity's employee id.",
  '171': "Other insurance coverage information.",
  '172': "Other employer name, address and telephone number.",
  '173': "Entity's full personal details.",
  '174': "Entity's student status.",
  '175': "Entity's school name.",
  '176': "Entity's school address.",
  '177': "Transplant recipient's details.",
  '178': "Total Claim Charge Amount.",
  '179': "Outside lab charges.",
  '180': "Hospital's semi-private room rate.",
  '181': "Hospital's room rate.",
  '182': "Allowable/paid from other entities coverage.",
  '183': "Amount entity has paid.",
  '184': "Purchase price for rented medical equipment.",
  '185': "Rental price for durable medical equipment.",
  '186': "Purchase and rental price of durable medical equipment.",
  '187': "Date(s) of service.",
  '188': "Statement from-through dates.",
  '189': "Facility admission date.",
  '190': "Facility discharge date.",
  '191': "Date of Last Menstrual Period (LMP).",
  '192': "Date of first service for current series/symptom/illness.",
  '193': "First consultation/evaluation date.",
  '194': "Confinement dates.",
  '195': "Unable to work dates/Disability Dates.",
  '196': "Return to work dates.",
  '197': "Effective coverage date(s).",
  '198': "Medicare effective date.",
  '199': "Date of conception and expected date of delivery.",
  '200': "Date of equipment return.",
  '201': "Date of dental appliance prior placement.",
  '202': "Date of dental prior replacement/reason for replacement.",
  '203': "Date of dental appliance placed.",
  '204': "Date dental canal(s) opened and date service completed.",
  '205': "Date(s) dental root canal therapy previously performed.",
  '206': "Most recent date of curettage, root planing, or periodontal surgery.",
  '207': "Dental impression and seating date.",
  '208': "Most recent date pacemaker was implanted.",
  '209': "Most recent pacemaker battery change date.",
  '210': "Date of the last x-ray.",
  '211': "Date(s) of dialysis training provided to patient.",
  '212': "Date of last routine dialysis.",
  '213': "Date of first routine dialysis.",
  '214': "Original date of prescription/orders/referral.",
  '215': "Date of tooth extraction/evolution.",
  '216': "Drug information.",
  '217': "Drug name, strength and dosage form.",
  '218': "NDC number.",
  '219': "Prescription number.",
  '222': "Drug dispensing units and average wholesale price (AWP).",
  '223': "Route of drug/myelogram administration.",
  '224': "Anatomical location for joint injection.",
  '225': "Anatomical location.",
  '226': "Joint injection site.",
  '227': "Hospital information.",
  '228': "Type of bill for UB claim.",
  '229': "Hospital admission source.",
  '230': "Hospital admission hour.",
  '231': "Hospital admission type.",
  '232': "Admitting diagnosis.",
  '233': "Hospital discharge hour.",
  '234': "Patient discharge status.",
  '235': "Units of blood furnished.",
  '158': "Entity's Date Of Birth!",
  '236': "Units of blood replaced.",
  '237': "Units of deductible blood.",
  '238': "Separate claim for mother/baby charges.",
  '239': "Dental information.",
  '240': "Tooth surface(s) involved.",
  '241': "List of all missing teeth (upper and lower).",
  '242': "Tooth numbers, surfaces, and/or quadrants involved.",
  '243': "Months of dental treatment remaining.",
  '244': "Tooth number or letter.",
  '245': "Dental quadrant/arch.",
  '246': "Total orthodontic service fee, initial appliance fee, monthly fee, length of service.",
  '247': "Line information.",
  '249': "Place of service.",
  '250': "Type of service.",
  '251': "Total anesthesia minutes.",
  '252': "Entity's prior authorization/certification number. Usage: This code requires the use of an Entity Code.",
  '254': "Principal diagnosis code.",
  '255': "Diagnosis code.",
  '256': "DRG code(s).",
  '257': "ADSM-III-R code for services rendered.",
  '258': "Days/units for procedure/revenue code.",
  '259': "Frequency of service.",
  '260': "Length of medical necessity, including begin date.",
  '261': "Obesity measurements.",
  '262': "Type of surgery/service for which anesthesia was administered.",
  '263': "Length of time for services rendered.",
  '264': "Number of liters/minute & total hours/day for respiratory support.",
  '265': "Number of lesions excised.",
  '266': "Facility point of origin and destination - ambulance.",
  '267': "Number of miles patient was transported.",
  '268': "Location of durable medical equipment use.",
  '269': "Length/size of laceration/tumor.",
  '270': "Subluxation location.",
  '271': "Number of spine segments.",
  '272': "Oxygen contents for oxygen system rental.",
  '273': "Weight.",
  '274': "Height.",
  '275': "Claim.",
  '276': "UB04/HCFA-1450/1500 claim form",
  '277': "Paper claim.",
  '279': "Claim/service must be itemized",
  '281': "Related confinement claim.",
  '282': "Copy of prescription.",
  '283': "Medicare entitlement information is required to determine primary coverage",
  '284': "Copy of Medicare ID card.",
  '286': "Other payer's Explanation of Benefits/payment information.",
  '287': "Medical necessity for service.",
  '288': "Hospital late charges",
  '290': "Pre-existing information.",
  '291': "Reason for termination of pregnancy.",
  '292': "Purpose of family conference/therapy.",
  '293': "Reason for physical therapy.",
  '294': "Supporting documentation. Usage: At least one other status code is required to identify the supporting documentation.",
  '295': "Attending physician report.",
  '296': "Nurse's notes.",
  '297': "Medical notes/report.",
  '298': "Operative report.",
  '299': "Emergency room notes/report.",
  '300': "Lab/test report/notes/results.",
  '301': "MRI report.",
  '305': "Radiology/x-ray reports and/or interpretation",
  '306': "Detailed description of service.",
  '307': "Narrative with pocket depth chart.",
  '308': "Discharge summary.",
  '310': "Progress notes for the six months prior to statement date.",
  '311': "Pathology notes/report.",
  '312': "Dental charting.",
  '313': "Bridgework information.",
  '314': "Dental records for this service.",
  '315': "Past perio treatment history.",
  '316': "Complete medical history.",
  '318': "X-rays/radiology films",
  '319': "Pre/post-operative x-rays/photographs.",
  '320': "Study models.",
  '322': "Recent Full Mouth X-rays",
  '323': "Study models, x-rays, and/or narrative.",
  '324': "Recent x-ray of treatment area and/or narrative.",
  '325': "Recent fm x-rays and/or narrative.",
  '326': "Copy of transplant acquisition invoice.",
  '327': "Periodontal case type diagnosis and recent pocket depth chart with narrative.",
  '329': "Exercise notes.",
  '330': "Occupational notes.",
  '331': "History and physical.",
  '333': "Patient release of information authorization.",
  '334': "Oxygen certification.",
  '335': "Durable medical equipment certification.",
  '336': "Chiropractic certification.",
  '337': "Ambulance certification/documentation.",
  '339': "Enteral/parenteral certification.",
  '340': "Pacemaker certification.",
  '341': "Private duty nursing certification.",
  '342': "Podiatric certification.",
  '343': "Documentation that facility is state licensed and Medicare approved as a surgical facility.",
  '344': "Documentation that provider of physical therapy is Medicare Part B approved.",
  '345': "Treatment plan for service/diagnosis",
  '346': "Proposed treatment plan for next 6 months.",
  '352': "Duration of treatment plan.",
  '353': "Orthodontics treatment plan.",
  '354': "Treatment plan for replacement of remaining missing teeth.",
  '360': "Benefits Assignment Certification Indicator",
  '363': "Possible Workers' Compensation",
  '364': "Is accident/illness/condition employment related?",
  '365': "Is service the result of an accident?",
  '366': "Is injury due to auto accident?",
  '374': "Is prescribed lenses a result of cataract surgery?",
  '375': "Was refraction performed?",
  '380': "CRNA supervision/medical direction.",
  '382': "Did provider authorize generic or brand name dispensing?",
  '383': "Nerve block use (surgery vs. pain management)",
  '384': "Is prosthesis/crown/inlay placement an initial placement or a replacement?",
  '385': "Is appliance upper or lower arch & is appliance fixed or removable?",
  '386': "Orthodontic Treatment/Purpose Indicator",
  '387': "Date patient last examined by entity. Usage: This code requires use of an Entity Code.",
  '388': "Date post-operative care assumed",
  '389': "Date post-operative care relinquished",
  '390': "Date of most recent medical event necessitating service(s)",
  '391': "Date(s) dialysis conducted",
  '394': "Date(s) of most recent hospitalization related to service",
  '395': "Date entity signed certification/recertification Usage: This code requires use of an Entity Code.",
  '396': "Date home dialysis began",
  '397': "Date of onset/exacerbation of illness/condition",
  '398': "Visual field test results",
  '400': "Claim is out of balance",
  '401': "Source of payment is not valid",
  '402': "Amount must be greater than zero. Usage: At least one other status code is required to identify which amount element is in error.",
  '403': "Entity referral notes/orders/prescription. Usage: this code requires use of an entity code.",
  '406': "Brief medical history as related to service(s)",
  '407': "Complications/mitigating circumstances",
  '408': "Initial certification",
  '409': "Medication logs/records (including medication therapy)",
  '414': "Necessity for concurrent care (more than one physician treating the patient)",
  '417': "Prior testing, including result(s) and date(s) as related to service(s)",
  '419': "Individual test(s) comprising the panel and the charges for each test",
  '420': "Name, dosage and medical justification of contrast material used for radiology procedure",
  '428': "Reason for transport by ambulance",
  '430': "Nearest appropriate facility",
  '431': "Patient's condition/functional status at time of service.",
  '432': "Date benefits exhausted",
  '433': "Copy of patient revocation of hospice benefits",
  '434': "Reasons for more than one transfer per entitlement period",
  '435': "Notice of Admission",
  '441': "Entity professional qualification for service(s). Usage: This code requires the use of an Entity Code.",
  '442': "Modalities of service",
  '443': "Initial evaluation report",
  '449': "Projected date to discontinue service(s)",
  '450': "Awaiting spend down determination",
  '451': "Preoperative and post-operative diagnosis",
  '452': "Total visits in total number of hours/day and total number of hours/week",
  '453': "Procedure Code Modifier(s) for Service(s) Rendered",
  '454': "Procedure code for services rendered.",
  '455': "Revenue code for services rendered.",
  '456': "Covered Day(s)",
  '457': "Non-Covered Day(s)",
  '458': "Coinsurance Day(s)",
  '459': "Lifetime Reserve Day(s)",
  '460': "NUBC Condition Code(s)",
  '464': "Payer Assigned Claim Control Number",
  '465': "Principal Procedure Code for Service(s) Rendered",
  '466': "Entity's Original Signature. Usage: This code requires use of an Entity Code.",
  '467': "Entity Signature Date. Usage: This code requires use of an Entity Code.",
  '468': "Patient Signature Source",
  '469': "Purchase Service Charge",
  '470': "Was service purchased from another entity? Usage: This code requires use of an Entity Code.",
  '471': "Were services related to an emergency?",
  '472': "Ambulance Run Sheet",
  '473': "Missing or invalid lab indicator",
  '474': "Procedure code and patient gender mismatch",
  '475': "Procedure code not valid for patient age",
  '476': "Missing or invalid units of service",
  '477': "Diagnosis code pointer is missing or invalid",
  '478': "Claim submitter's identifier",
  '479': "Other Carrier payer ID is missing or invalid",
  '480': "Entity's claim filing indicator. Usage: This code requires use of an Entity Code.",
  '481': "Claim/submission format is invalid.",
  '483': "Maximum coverage amount met or exceeded for benefit period.",
  '484': "Business Application Currently Not Available",
  '485': "More information available than can be returned in real-time mode. Narrow your current search criteria.",
  '486': "Principal Procedure Date",
  '487': "Claim not found, claim should have been submitted to/through 'entity'. Usage: This code requires use of an Entity Code.",
  '488': "Diagnosis code(s) for the services rendered.",
  '489': "Attachment Control Number",
  '490': "Other Procedure Code for Service(s) Rendered",
  '491': "Entity not eligible for encounter submission. Usage: This code requires use of an Entity Code.",
  '492': "Other Procedure Date",
  '493': "Version/Release/Industry ID code not currently supported by information holder",
  '494': "Real-time requests not supported by the information holder, resubmit as batch request.",
  '495': "Requests for re-adjudication must reference the newly assigned payer claim control number for this previously adjusted claim. Correct the payer claim control number and re-submit.",
  '496': "Submitter not approved for electronic claim submissions on behalf of this entity. Usage: This code requires use of an Entity Code.",
  '497': "Sales tax not paid",
  '498': "Maximum leave days exhausted",
  '499': "No rate on file with the payer for this service for this entity Usage: This code requires use of an Entity Code.",
  '500': "Entity's Postal/Zip Code. Usage: This code requires use of an Entity Code.",
  '501': "Entity's State/Province. Usage: This code requires use of an Entity Code.",
  '502': "Entity's City. Usage: This code requires use of an Entity Code.",
  '503': "Entity's Street Address. Usage: This code requires use of an Entity Code.",
  '504': "Entity's Last Name. Usage: This code requires use of an Entity Code.",
  '505': "Entity's First Name. Usage: This code requires use of an Entity Code.",
  '506': "Entity is changing processor/clearinghouse. This claim must be submitted to the new processor/clearinghouse. Usage: This code requires use of an Entity Code.",
  '507': "HCPCS",
  '508': "ICD9 Usage: At least one other status code is required to identify the related procedure code or diagnosis code.",
  '509': "External Cause of Injury Code.",
  '510': "Future date. Usage: At least one other status code is required to identify the data element in error.",
  '511': "Invalid character. Usage: At least one other status code is required to identify the data element in error."
};

const entityCodes = {
  'QC': 'Patient',
  'PR': 'Payer',
  // Add all other entity codes here
};
  const segments = ediString.split('~').map(s => s.trim());
  let claimStatus = "Unknown";
  let errors = [];
  let successMessages = [];
  let transactionType = "Unknown";
  let acknowledgmentStatus = "Unknown"; // For 999 responses

  // Determine transaction type
  const stSegment = segments.find(segment => segment.startsWith('ST*'));
  if (stSegment) {
    const transactionCode = stSegment.split('*')[1];
    transactionType = transactionCode === '277' ? '277' : transactionCode === '999' ? '999' : 'Unknown';
  }

  // Handle 999 Response
  if (transactionType === "999") {
    for (let segment of segments) {
      if (segment.startsWith('AK9')) {
        const fields = segment.split('*');
        const statusCode = fields[1]; // R, E, A, etc.

        switch (statusCode) {
          case 'A': acknowledgmentStatus = "Accepted"; break;
          case 'E': acknowledgmentStatus = "Accepted with Errors"; break;
          case 'R': acknowledgmentStatus = "Rejected"; break;
          default: acknowledgmentStatus = `Unknown Status (Code: ${statusCode})`; break;
        }
      } else if (segment.startsWith('IK5')) {
        const fields = segment.split('*');
        const errorCode = fields[2] || "Unknown Error";

        // Add error message mapping
        const errorMessages = {
          '1': "Transaction Set Not Supported",
          '2': "Transaction Set Trailer Missing",
          '3': "Transaction Set Control Number Mismatch",
          '4': "Implementation Convention Not Supported",
          '5': "Implementation Convention Version Not Supported",
          '6': "Segment Missing",
          '7': "Unexpected Segment Found",
          '8': "Segment Repeat Exceeded",
          '9': "Segment Too Short",
          '10': "Segment Too Long"
        };

        let errorMessage = errorMessages[errorCode] || `Unknown Error Code: ${errorCode}`;
        errors.push(errorMessage);
      }
    }
    return { transactionType, acknowledgmentStatus, errors };
  }

  // Handle 277 Response
  for (let segment of segments) {
    if (segment.startsWith('STC')) {
      const fields = segment.split('*');
      const statusComponents = fields[1].split(':');
      const [categoryCode, statusCode, entityCode] = statusComponents;

      const categoryDescription = claimStatusCategoryCodes[categoryCode] || `Unknown Category Code: ${categoryCode}`;
      const statusDescription = claimStatusCodes[statusCode] || `Unknown Status Code: ${statusCode}`;
      const entityDescription = entityCodes[entityCode] || `Unknown Entity Code: ${entityCode}`;

      const statusMessage = `${categoryDescription} - ${statusDescription} (Entity: ${entityDescription})`;

      if (categoryCode.startsWith('E')) {
        errors.push(statusMessage);
      } else {
        successMessages.push(statusMessage);
      }
    }
  }

  return { transactionType, claimStatus, errors, successMessages };
};


 
export default ParseX12Data;
 
